var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJostRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Aug 27 10:29:47 2020\n By Aleksey,,,\nCopyright 2020 The Jost Project Authors (https://github.com/indestructible-type)\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Jost-Regular",
    horizAdvX: 570
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Jost",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 800,
    descent: -200,
    xHeight: 460,
    capHeight: 700,
    bbox: "-111 -350 1476 1030",
    underlineThickness: 50,
    underlinePosition: -175,
    unicodeRange: "U+000D-FF19"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 500,
    d: "M50 -200h400v1000h-400v-1000zM100 -150v900h300v-900h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 500,
    d: "M50 -200h400v1000h-400v-1000zM100 -150v900h300v-900h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0000",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0000",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni000D",
    unicode: "\r",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 300,
    d: "M100 700h100l-20 -500h-60zM95 40q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 465,
    d: "M130 700h95l-90 -300h-55zM310 700h95l-90 -300h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 605,
    d: "M35 200v65h104l43 175h-107v65h123l47 195h75l-47 -195h135l47 195h75l-47 -195h87v-65h-103l-43 -175h106v-65h-121l-49 -200h-75l48 200h-134l-49 -200h-75l49 200h-89zM214 265h136l42 175h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 580,
    d: "M440 514q-15 29 -34 55.5t-46 43t-66 16.5q-60 0 -87.5 -24.5t-27.5 -70.5q0 -38 23 -62.5t60 -42t79 -33.5q27 -10 58 -26t58 -39.5t44 -58t17 -82.5q0 -83 -47 -137t-138 -62v-103h-74v106q-70 14 -123 64.5t-81 124.5l72 43q32 -72 75 -114t108 -42q60 0 90 30.5 t30 82.5q0 45 -24.5 74t-62 48t-77.5 33q-26 9 -56.5 24t-57.5 38.5t-44.5 57.5t-17.5 82q0 43 22 78.5t60 59t87 30.5v110h74v-111q45 -8 80.5 -31t59.5 -54t36 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 751,
    d: "M35 550q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM563 700h75l-450 -700h-75zM106 550q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5 t-23 -66.5zM400 150q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM471 150q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5t-23 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 675,
    d: "M559 0l-69 79q-48 -40 -103.5 -64.5t-121.5 -24.5q-57 0 -108.5 23.5t-84 67t-32.5 102.5q0 45 16.5 79t42.5 59t56 43t57 32q-18 18 -40 42.5t-38.5 53.5t-16.5 64q0 71 48 113t123 42q53 0 90.5 -22t57.5 -57.5t20 -77.5q0 -47 -34.5 -91t-96.5 -83l169 -195 q29 29 56 62.5t52 68.5l62 -39q-29 -38 -59 -76t-62 -72l112 -129h-96zM201 556q0 -33 24.5 -62.5t53.5 -61.5q45 29 70.5 60.5t25.5 61.5q0 38 -23 62t-64 24t-64 -23t-23 -61zM125 188q0 -57 42.5 -90.5t102.5 -33.5q46 0 88.5 19.5t82.5 51.5l-182 208q-32 -18 -63 -38.5 t-51 -49t-20 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 285,
    d: "M130 700h95l-90 -300h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 310,
    d: "M205 780h75q-52 -112 -76 -237t-24 -253q0 -127 24 -252t76 -238h-75q-60 113 -87.5 238t-27.5 252q0 128 27.5 253t87.5 237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 310,
    d: "M105 -200h-75q53 113 76.5 238t23.5 252q0 128 -23.5 253t-76.5 237h75q60 -112 87.5 -237t27.5 -253q0 -127 -27.5 -252t-87.5 -238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 592,
    d: "M210 327l-57 41l99 123l-152 41l21 67l148 -57l-8 158h70l-8 -158l148 57l21 -67l-152 -41l99 -123l-57 -41l-86 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 615,
    d: "M65 215v80h200v205h85v-205h200v-80h-200v-205h-85v205h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 308,
    d: "M148 110l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 210,
    d: "M5 200v75h200v-75h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 300,
    d: "M95 40q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 515,
    d: "M420 700h80l-405 -850h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 600,
    d: "M40 350q0 105 33 186t91.5 127.5t135.5 46.5t135.5 -46.5t91.5 -127.5t33 -186t-33 -186t-91.5 -127.5t-135.5 -46.5t-135.5 46.5t-91.5 127.5t-33 186zM125 350q0 -81 21.5 -144.5t60.5 -99.5t93 -36t93.5 36t60.5 99.5t21 144.5q0 82 -21 145t-60.5 99t-93.5 36 t-93 -36t-60.5 -99t-21.5 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 450,
    d: "M80 562v88l240 60v-710h-85v608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 569,
    d: "M20 0l331 353q35 37 54 74t19 79q0 31 -16 59.5t-46 47t-73 18.5q-67 0 -105.5 -45.5t-38.5 -125.5h-85q0 75 27 131.5t78.5 88t123.5 31.5q58 0 100 -19.5t69 -50t40 -65.5t13 -67q0 -54 -26 -107t-67 -95l-223 -227h319v-80h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 546,
    d: "M283 -10q-67 0 -117.5 26t-78 70.5t-27.5 98.5h86q0 -49 38.5 -82t98.5 -33t95.5 34t35.5 91q0 65 -46.5 97.5t-114.5 32.5v75q68 0 104.5 36t36.5 85q0 50 -26.5 81t-79.5 31q-49 0 -83 -30.5t-34 -76.5h-81q0 55 25.5 96t70 64.5t101.5 23.5q60 0 103.5 -26t67 -68 t23.5 -92q0 -52 -32 -94t-87 -65q62 -18 100.5 -62t38.5 -118q0 -59 -28.5 -103t-77.5 -68t-112 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 583,
    d: "M20 140l388 560h35v-485h110v-75h-110v-140h-85v140h-338zM160 215h198v296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 564,
    d: "M524 230q0 -79 -33 -132.5t-88.5 -80.5t-123.5 -27q-64 0 -111.5 20t-81 53.5t-56.5 73.5l72 49q16 -30 42.5 -56.5t61.5 -43t73 -16.5q75 0 116 44t41 116q0 48 -20.5 84t-56 56t-80.5 20q-33 0 -60.5 -5.5t-55 -19t-63.5 -38.5l92 373h330v-75h-264l-47 -185 q50 26 104 26q60 0 107.5 -30t74.5 -83t27 -123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 576,
    d: "M330 700h107l-197 -260q17 10 36.5 13.5t42.5 3.5q57 0 104 -30t75 -81t28 -116q0 -72 -31.5 -126t-85 -84t-121.5 -30q-67 0 -121 30t-85.5 84t-31.5 126q0 43 12 80t32 65zM131 230q0 -48 20.5 -84.5t56 -57.5t80.5 -21t80.5 21t56 57.5t20.5 84.5t-20.5 85.5t-56 58.5 t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 525,
    d: "M30 620v80h490l-335 -700h-89l297 620h-363z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 546,
    d: "M55 190q0 69 35.5 115.5t88.5 67.5q-46 20 -72.5 60.5t-26.5 97.5q0 50 25.5 90.5t69 64.5t98.5 24t98.5 -24t69 -64.5t25.5 -90.5q0 -57 -26.5 -97.5t-72.5 -60.5q53 -21 88.5 -67.5t35.5 -115.5q0 -54 -28.5 -99.5t-77.5 -73t-112 -27.5q-62 0 -111.5 27.5t-78 73 t-28.5 99.5zM161 521q0 -49 33.5 -80t78.5 -31t78.5 31t33.5 80q0 50 -31.5 82t-80.5 32t-80.5 -32t-31.5 -82zM136 200q0 -43 19.5 -73t51 -46t66.5 -16t66.5 16t51 46t19.5 73q0 38 -19.5 68.5t-51 48.5t-66.5 18t-66.5 -18t-51 -48.5t-19.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 576,
    d: "M246 0h-107l197 260q-17 -10 -36.5 -13.5t-42.5 -3.5q-57 0 -104 30t-75 81.5t-28 115.5q0 72 31.5 126t85.5 84t121 30q68 0 121.5 -30t85 -84t31.5 -126q0 -43 -12 -80t-32 -65zM445 470q0 48 -20.5 84.5t-56 57.5t-80.5 21t-80.5 -21t-56 -57.5t-20.5 -84.5t20.5 -85 t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 300,
    d: "M95 420q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM95 40q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 330,
    d: "M125 420q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM148 110l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 640,
    d: "M197 262l378 -167v-80l-510 220v45l510 220v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 615,
    d: "M65 290v75h485v-75h-485zM65 140v75h485v-75h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 640,
    d: "M443 253l-378 167v80l510 -220v-45l-510 -220v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 557,
    d: "M416 500q0 65 -39.5 100t-107.5 35q-50 0 -85.5 -22.5t-58.5 -60.5l-65 41q23 35 51 61.5t68.5 41t99.5 14.5q63 0 112 -27.5t77.5 -75t28.5 -107.5q0 -57 -30 -103.5t-78 -75t-104 -31.5l-7 -120h-60l-20 175h26q60 0 103 23t66 58.5t23 73.5zM195 40q0 23 16.5 39 t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 770,
    d: "M35 320q0 82 27.5 153t78.5 124t120.5 83t153.5 30q80 0 140 -27t100 -73t60 -103t20 -117q0 -66 -17 -112t-44.5 -74t-58.5 -41t-59 -13q-37 0 -61.5 23.5t-28.5 59.5q-24 -36 -60 -54.5t-78 -18.5q-36 0 -67.5 18.5t-51 54t-19.5 84.5q0 70 29.5 117t73 71.5t85.5 24.5 q40 0 67 -22t40 -55l10 67h75l-41 -231q-2 -14 -2 -27q0 -18 7 -32t32 -14q15 0 38.5 17t42 55.5t18.5 101.5q0 67 -27.5 125t-83 94t-139.5 36q-94 0 -163.5 -43t-108 -116.5t-38.5 -165.5q0 -81 32 -140.5t90.5 -92t137.5 -32.5q53 0 102.5 10.5t98.5 41.5l35 -57 q-45 -27 -97.5 -43.5t-138.5 -16.5q-107 0 -180.5 41t-111.5 115.5t-38 173.5zM266 320q0 -42 20.5 -66t61.5 -24q25 0 52 13t46 43.5t19 83.5q0 42 -24.5 66t-62.5 24q-27 0 -53 -17t-42.5 -48.5t-16.5 -74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 660,
    d: "M560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 558,
    d: "M508 205q0 -69 -31.5 -114.5t-85 -68t-121.5 -22.5h-190v700h180q94 0 151 -43t57 -132q0 -54 -31 -90.5t-85 -52.5q69 -14 112.5 -57.5t43.5 -119.5zM260 625h-95v-208h95q53 0 88 27t35 76q0 50 -35 77.5t-88 27.5zM165 75h105q68 0 110.5 35.5t42.5 99.5 q0 65 -42.5 99t-110.5 34h-105v-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 685,
    d: "M130 350q0 -81 36.5 -143t95.5 -97t128 -35q74 0 131 29t94 75v-112q-44 -39 -96 -58t-129 -19q-73 0 -136.5 26.5t-111.5 75t-75 114.5t-27 144t27 144t75 114.5t111.5 75t136.5 26.5q77 0 129 -19t96 -58v-112q-37 47 -94 75.5t-131 28.5q-69 0 -128 -35t-95.5 -96.5 t-36.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 680,
    d: "M290 0h-210v700h210q102 0 181 -44t124 -122.5t45 -183.5t-45 -183.5t-124 -122.5t-181 -44zM290 615h-125v-530h125q79 0 138.5 32.5t93 92t33.5 140.5q0 82 -33.5 141t-93 91.5t-138.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 550,
    d: "M80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 500,
    d: "M80 700h360v-80h-275v-200h265v-80h-265v-340h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 775,
    d: "M405 275v80h325q0 -73 -22 -138.5t-65 -116.5t-105.5 -80.5t-142.5 -29.5q-76 0 -141 26.5t-113 75t-74.5 114.5t-26.5 144t26.5 144t74.5 114.5t113 75t141 26.5q97 0 171.5 -38t119.5 -111l-60 -55q-33 56 -92 87.5t-139 31.5q-74 0 -134 -35t-95.5 -96.5t-35.5 -143.5 q0 -81 35.5 -143t95.5 -97t134 -35q70 0 120 27.5t81 73t42 99.5h-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 715,
    d: "M80 700h85v-280h385v280h85v-700h-85v340h-385v-340h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 245,
    d: "M80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 240,
    d: "M-67 -104q22 -36 79 -36q23 0 45.5 20.5t22.5 69.5v750h80v-760q0 -82 -41 -121t-112 -39q-40 0 -73.5 17.5t-44.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 565,
    d: "M80 700h85v-301l275 301h105l-303 -328l318 -372h-105l-290 340v-340h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 450,
    d: "M80 700h85v-620h275v-80h-360v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 810,
    d: "M177 473l-52 -473h-85l85 735l280 -507l280 507l85 -735h-85l-52 473l-228 -408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 775,
    d: "M610 700h85v-735l-530 556v-521h-85v735l530 -556v521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 790,
    d: "M40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350q0 -79 34.5 -141t94.5 -98t136 -36 q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 548,
    d: "M80 700h190q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -64 -31.5 -111.5t-85 -73t-121.5 -25.5h-105v-280h-85v700zM270 620h-105v-260h105q68 0 110.5 33t42.5 97q0 65 -42.5 97.5t-110.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 790,
    d: "M40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -67 -21 -126t-58 -106l118 -118h-110l-64 64q-44 -35 -100 -54.5t-120 -19.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350q0 -79 34.5 -141 t94.5 -98t136 -36q46 0 86 13t72 38l-174 174h110l119 -119q25 34 38.5 77t13.5 92q0 79 -34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 560,
    d: "M80 700h190q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -79 -46.5 -131.5t-120.5 -70.5l209 -288h-105l-195 280h-85v-280h-85v700zM270 625h-105v-270h105q68 0 110.5 35.5t42.5 99.5q0 65 -42.5 100t-110.5 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 548,
    d: "M106 212q35 -64 78.5 -103t106.5 -39q56 0 90 31t34 79q0 47 -22 75t-57.5 45.5t-75.5 31.5q-26 9 -58 23.5t-61 37t-47.5 55.5t-18.5 81q0 52 26 93t72 64.5t105 23.5q57 0 99.5 -21.5t72.5 -55t47 -70.5l-73 -42q-13 26 -33 51t-48.5 41t-69.5 16q-57 0 -83 -27.5 t-26 -61.5q0 -44 35 -77t127 -65q28 -10 59 -26t57.5 -40.5t43.5 -59t17 -82.5q0 -61 -30.5 -106t-79.5 -69.5t-105 -24.5q-57 0 -105.5 24.5t-85 65t-59.5 86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 465,
    d: "M10 620v80h445v-80h-180v-620h-85v620h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 626,
    d: "M75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 660,
    d: "M330 158l230 542h95l-325 -735l-325 735h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 990,
    d: "M703 185l182 515h95l-275 -735l-210 544l-210 -544l-275 735h95l186 -515l204 550z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 555,
    d: "M430 700h100l-207 -333l222 -367h-100l-165 293l-170 -293h-100l228 367l-203 333h100l146 -259z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 561,
    d: "M461 700h95l-233 -398v-302h-85v301l-233 399h95l180 -324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 545,
    d: "M35 620v80h490l-368 -620h348v-80h-490l368 620h-348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 300,
    d: "M179 705v-850h101v-75h-180v1000h180v-75h-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 515,
    d: "M15 700h85l400 -700h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 300,
    d: "M121 -145v850h-101v75h180v-1000h-180v75h101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 510,
    d: "M255 621l-110 -161h-80l170 250h40l170 -250h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M0 -133v55h500v-55h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 375,
    d: "M75 660l75 40l150 -160l-45 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 481,
    d: "M99 354l-39 59q26 19 71.5 38t109.5 19q80 0 130 -36.5t50 -103.5v-330h-80v62q-22 -36 -66 -54t-86 -18t-78.5 17.5t-58.5 50.5t-22 80q0 67 47.5 107.5t132.5 40.5q46 0 78.5 -10.5t52.5 -23.5v67q0 47 -30.5 64t-73.5 17q-52 0 -87 -17t-51 -29zM111 142 q0 -40 27.5 -61.5t71.5 -21.5q55 0 93 33t38 88v17q-28 14 -57 20t-61 6q-58 0 -85 -21.5t-27 -59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M535 230q0 -74 -31 -128t-82.5 -83t-114.5 -29q-51 0 -91.5 23t-65.5 66v-79h-80v780h80v-399q25 43 65.5 66t91.5 23q63 0 114.5 -29t82.5 -82.5t31 -128.5zM454 230q0 53 -21.5 90t-57 56t-78.5 19q-35 0 -69 -19t-56 -56t-22 -90t22 -90t56 -56t69 -19q43 0 78.5 19 t57 56t21.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 478,
    d: "M111 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-24 -28 -68.5 -43.5t-91.5 -15.5q-67 0 -121 31t-85.5 85.5t-31.5 123.5q0 70 31.5 124t85.5 85t121 31q47 0 91.5 -15.5t68.5 -43.5v-100q-16 34 -60 59t-100 25q-45 0 -80.5 -21t-56 -58.5 t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M35 230q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v399h80v-780h-80v79q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56 t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 515,
    d: "M253 -10q-64 0 -113.5 30.5t-77 84.5t-27.5 125q0 72 28.5 126t80 84t119.5 30q101 0 159 -63t58 -173q0 -7 -0.5 -14.5t-0.5 -9.5h-362q5 -69 43 -107t103 -38q94 0 144 83l65 -41q-72 -117 -219 -117zM263 400q-59 0 -96 -31.5t-47 -90.5h273q-4 55 -39.5 88.5 t-90.5 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 286,
    d: "M40 460h45v170q0 82 35 121t98 39q32 0 54.5 -12.5t33.5 -27.5l-44 -66q-10 17 -23.5 21.5t-25.5 4.5q-22 0 -35 -20t-13 -70v-160h105v-75h-105v-385h-80v385h-45v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M44 -30h81q0 -33 18 -61.5t51 -46t78 -17.5q35 0 69 17t56.5 53.5t22.5 94.5v69q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v79h80v-450q0 -79 -33 -132.5t-85 -80.5t-110 -27q-67 0 -118.5 25 t-80.5 70.5t-29 104.5zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 525,
    d: "M370 280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v780h80v-393q21 38 56.5 60.5t80.5 22.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 260,
    d: "M75 650q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 250,
    d: "M62 650q0 23 16 38.5t38 15.5q23 0 38.5 -15.5t15.5 -38.5q0 -22 -15.5 -38t-38.5 -16q-22 0 -38 16t-16 38zM-17 -114q16 -26 49 -26q26 0 37 21t11 69v510h80v-520q0 -76 -35 -118t-98 -42q-58 0 -88 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 440,
    d: "M320 460h100l-200 -190l220 -270h-100l-190 233v-233h-80v780h80v-481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 230,
    d: "M75 780h80v-780h-80v780z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 780,
    d: "M705 290v-290h-80v280q0 59 -21.5 87t-66.5 28q-49 0 -78 -30.5t-29 -84.5v-280h-80v280q0 59 -21.5 87t-66.5 28q-49 0 -78 -30.5t-29 -84.5v-280h-80v460h80v-67q41 77 127 77q48 0 82.5 -22.5t50.5 -63.5q48 86 142 86q71 0 109.5 -47t38.5 -133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 525,
    d: "M370 280q0 115 -98 115q-52 0 -84.5 -32t-32.5 -83v-280h-80v460h80v-72q45 82 137 82q73 0 115.5 -48.5t42.5 -131.5v-290h-80v280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 546,
    d: "M35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21 t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M150 -220h-80v680h80v-79q25 43 65.5 66t91.5 23q63 0 114.5 -29t82.5 -82.5t31 -128.5q0 -74 -31 -128t-82.5 -83t-114.5 -29q-51 0 -91.5 23t-65.5 66v-299zM454 230q0 53 -21.5 90t-57 56t-78.5 19q-35 0 -69 -19t-56 -56t-22 -90t22 -90t56 -56t69 -19q43 0 78.5 19 t57 56t21.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M35 230q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v79h80v-680h-80v299q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56 t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 343,
    d: "M294 372q-16 12 -29 17.5t-33 5.5q-45 0 -61 -32.5t-16 -82.5v-280h-80v460h80v-53q19 29 45 46t52 17q25 0 46.5 -6.5t39.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 403,
    d: "M94 141q21 -32 51.5 -55t73.5 -23q34 0 53.5 15.5t19.5 42.5q0 24 -15.5 40.5t-39.5 28t-51 21.5q-30 12 -60.5 28.5t-51 43t-20.5 66.5q0 41 21.5 68t56 40t71.5 13q55 0 100 -26t66 -64l-64 -41q-19 26 -47.5 43t-64.5 17q-25 0 -43 -11t-18 -34q0 -28 29.5 -45.5 t66.5 -32.5q40 -16 73 -34.5t52.5 -44.5t19.5 -67q0 -60 -43.5 -100t-114.5 -40q-46 0 -83 16.5t-62.5 42.5t-38.5 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 240,
    d: "M5 460h75v160h80v-160h75v-75h-75v-385h-80v385h-75v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 525,
    d: "M155 180q0 -55 25 -85t73 -30q53 0 85 32t32 83v280h80v-460h-80v72q-46 -82 -137 -82q-72 0 -115 49t-43 131v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 440,
    d: "M0 460h90l130 -325l130 325h90l-220 -495z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 680,
    d: "M5 460h90l115 -299l125 334l134 -336l116 301h90l-200 -495l-139 335l-131 -335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 420,
    d: "M320 460h90l-157 -223l167 -237h-90l-120 174l-120 -174h-90l167 237l-157 223h90l110 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 440,
    d: "M440 460l-300 -680h-90l126 285l-176 395h95l129 -317l126 317h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 460,
    d: "M300 385h-255v75h400l-285 -385h265v-75h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 311,
    d: "M178 660v-170q0 -37 -3.5 -77.5t-17 -74t-45.5 -48.5q32 -15 45.5 -48.5t17 -74t3.5 -77.5v-170q0 -19 13 -34.5t35 -15.5h35v-70h-60q-22 0 -46 14.5t-40.5 45.5t-16.5 80v210q0 57 -12.5 80t-35.5 30v60q23 8 35.5 30.5t12.5 79.5v210q0 50 16.5 80.5t40.5 45t46 14.5 h60v-70h-35q-22 0 -35 -15t-13 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 274,
    d: "M100 785h74v-1000h-74v1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 311,
    d: "M142 -80v170q0 37 3.5 77.5t17 74t45.5 48.5q-32 15 -45.5 48.5t-17 74t-3.5 77.5v170q0 20 -12.5 35t-35.5 15h-35v70h60q22 0 46 -14.5t40.5 -45t16.5 -80.5v-210q0 -57 13 -79.5t35 -30.5v-60q-22 -7 -35 -30t-13 -80v-210q0 -49 -16.5 -80t-40.5 -45.5t-46 -14.5h-60 v70h35q23 0 35.5 15.5t12.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 575,
    d: "M142 176l-74 5q-3 11 -3 24q0 16 5.5 34t18.5 36q20 26 47 39t58 13q60 0 123 -48q23 -17 41.5 -24.5t31.5 -7.5q42 0 42 49q0 6 -1 13t-4 14l79 -5q2 -6 3 -13t1 -15q0 -15 -4.5 -34.5t-17.5 -36.5q-19 -25 -43 -36t-51 -11q-50 0 -115 48q-22 17 -44.5 25t-41.5 8 q-55 0 -55 -55q0 -11 4 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 300,
    d: "M205 415q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39zM200 -245h-100l20 500h60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 580,
    d: "M162 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-21 -25 -57.5 -39.5t-77.5 -18.5v-103h-64v105q-58 9 -103 41.5t-70.5 82.5t-25.5 113t25.5 113t70.5 82.5t103 41.5v111h64v-109q41 -4 77.5 -19t57.5 -39v-100q-16 34 -60 59t-100 25 q-45 0 -80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 580,
    d: "M67 370h98q-19 28 -34 63t-15 85q0 60 26.5 103t73 66t105.5 23q50 0 87 -20t61 -51t37 -66t15 -65l-71 -29q-2 37 -16 70.5t-42 55t-71 21.5q-30 0 -57 -10.5t-44 -34t-17 -61.5q0 -35 9.5 -60.5t23.5 -46.5t28 -43h163v-75h-132q3 -15 3 -31q0 -58 -25.5 -106.5 t-62.5 -77.5h307v-80h-453q49 51 83 90.5t52 77t18 81.5q0 23 -9 46h-141v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 580,
    d: "M87 47l-50 50l60 59q-22 29 -33.5 65.5t-11.5 78.5t11.5 78.5t33.5 65.5l-60 59l50 50l59 -59q29 22 66 34t78 12t77.5 -12t66.5 -34l59 59l49 -50l-59 -59q22 -29 33.5 -65.5t11.5 -78.5t-11.5 -78.5t-33.5 -65.5l59 -59l-49 -50l-59 59q-30 -22 -66.5 -34t-77.5 -12 t-78 12t-66 34zM133 300q0 -48 20.5 -85.5t56 -58.5t80.5 -21t80.5 21t56 58.5t20.5 85.5t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 580,
    d: "M45 140v75h203v75h-203v75h167l-197 335h95l180 -324l181 324h94l-196 -335h161v-75h-196v-75h196v-75h-196v-140h-86v140h-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 274,
    d: "M100 695h74v-240h-74v240zM174 245v-240h-74v240h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 408,
    d: "M96 161q9 -42 42.5 -69t76.5 -27q38 0 59 14t21 44q0 25 -15 41.5t-38.5 28.5t-50.5 22q-31 13 -61.5 31.5t-50.5 46.5t-20 66q0 88 93 112q-37 18 -65 45t-28 73q0 38 22 65t56 41.5t71 14.5t71.5 -12t60 -32t34.5 -46l-64 -41q-15 29 -44 42t-57 13q-30 0 -50 -11 t-20 -34q0 -18 17.5 -33t43.5 -27t51 -23q33 -13 62 -32t47 -44.5t18 -59.5q0 -53 -24.5 -81.5t-65.5 -39.5q37 -20 63.5 -49t26.5 -70q0 -74 -47 -107t-121 -33q-42 0 -81 17.5t-65.5 48t-33.5 67.5zM139 369q0 -41 26.5 -60.5t59.5 -32.5q31 7 50.5 33.5t19.5 53.5 q0 33 -25.5 51.5t-59.5 32.5q-36 -14 -53.5 -32.5t-17.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 470,
    d: "M280 660q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM80 660q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 800,
    d: "M40 350q0 78 27.5 144t76 114.5t114.5 75t142 26.5q77 0 142.5 -26.5t114 -75t76 -114.5t27.5 -144t-27.5 -144t-76 -114.5t-114 -75t-142.5 -26.5q-76 0 -142 26.5t-114.5 75t-76 114.5t-27.5 144zM95 350q0 -89 40 -159t109.5 -110.5t155.5 -40.5q87 0 156 40.5 t109 110.5t40 159t-40 159t-109 110.5t-156 40.5q-86 0 -155.5 -40.5t-109.5 -110.5t-40 -159zM239 350q0 -49 20.5 -86t56 -58t79.5 -21t78.5 17t56.5 45v-67q-26 -23 -57.5 -34.5t-77.5 -11.5q-58 0 -105.5 28t-76 77t-28.5 111q0 63 28.5 111.5t76 76.5t105.5 28 q46 0 77.5 -11.5t57.5 -34.5v-67q-22 28 -56.5 45t-78.5 17t-79.5 -21t-56 -58t-20.5 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 238,
    d: "M61 646l-19 31q13 9 35 18.5t53 9.5q39 0 63.5 -18.5t24.5 -51.5v-175h-40v33q-10 -18 -31 -28t-47 -10q-31 0 -55.5 20t-24.5 57q0 36 30.5 58.5t67.5 22.5q20 0 35 -5t25 -12v39q0 17 -14.5 26t-33.5 9q-25 0 -43 -9t-26 -15zM61 532q0 -16 10.5 -28.5t38.5 -12.5 q26 0 47 13.5t21 45.5v19q-26 14 -58 14q-27 0 -43 -15t-16 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 510,
    d: "M290 259l150 -194l-50 -45l-190 235l190 235l50 -45zM130 259l150 -194l-50 -45l-190 235l190 235l50 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 620,
    d: "M65 300v75h490v-200h-75v125h-415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 210,
    d: "M5 200v75h200v-75h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 800,
    d: "M40 350q0 78 27.5 144t76 114.5t114.5 75t142 26.5q77 0 142.5 -26.5t114 -75t76 -114.5t27.5 -144t-27.5 -144t-76 -114.5t-114 -75t-142.5 -26.5q-76 0 -142 26.5t-114.5 75t-76 114.5t-27.5 144zM95 350q0 -89 40 -159t109.5 -110.5t155.5 -40.5q87 0 156 40.5 t109 110.5t40 159t-40 159t-109 110.5t-156 40.5q-86 0 -155.5 -40.5t-109.5 -110.5t-40 -159zM274 570h114q61 0 102 -34t41 -92q0 -47 -28 -78.5t-72 -42.5l125 -173h-63l-117 168h-51v-168h-51v420zM388 525h-63v-162h63q41 0 66.5 21t25.5 60t-25.5 60t-66.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 510,
    d: "M80 600v75h350v-75h-350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 278,
    d: "M20 600q0 53 34 86.5t85 33.5t85 -33.5t34 -86.5q0 -52 -34 -86t-85 -34t-85 34t-34 86zM60 600q0 -36 22.5 -59t56.5 -23t56.5 23t22.5 59t-22.5 59t-56.5 23t-56.5 -23t-22.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 615,
    d: "M65 345v80h200v195h85v-195h200v-80h-200v-195h-85v195h-200zM65 0v80h485v-80h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    horizAdvX: 346,
    d: "M25 282l198 212q21 22 32.5 44.5t11.5 47.5q0 28 -19 51.5t-57 23.5q-40 0 -65.5 -27.5t-25.5 -75.5h-51q0 67 38.5 109t103.5 42q46 0 74 -20t41 -49.5t13 -57.5q0 -32 -15.5 -61t-40.5 -55l-133 -136h191v-48h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    horizAdvX: 312,
    d: "M159 274q-61 0 -97.5 34t-36.5 83h52q0 -30 23 -49.5t59 -19.5t57.5 20.5t21.5 54.5q0 39 -28 58.5t-69 19.5v45q41 0 63 21.5t22 51.5t-16 48.5t-48 18.5q-29 0 -49.5 -18t-20.5 -46h-49q0 49 33.5 79.5t85.5 30.5q54 0 85 -34t31 -78q0 -31 -19 -56.5t-52 -38.5 q36 -11 59.5 -37.5t23.5 -70.5q0 -53 -37.5 -85t-93.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 375,
    d: "M300 660l-180 -150l-45 30l150 160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 525,
    d: "M155 460v-280q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v62q-24 -34 -59.5 -53t-77.5 -19q-45 0 -78 18v-328h-80v780h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 578,
    d: "M288 270q-62 0 -114 25t-83 73t-31 117q0 70 31 117.5t83 72.5t114 25h230v-920h-70v855h-90v-855h-70v490z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 300,
    d: "M95 240q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 350,
    d: "M196 60h61l-64 -112h9q25 0 49 -18.5t24 -55.5q0 -46 -33 -70t-74 -24q-28 0 -48 8.5t-41 29.5l33 40q14 -12 25.5 -18t30.5 -6q26 0 38 11t12 29q0 36 -50 36q-7 0 -24 -3.5t-33 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    horizAdvX: 470,
    d: "M152 611v53l144 36v-426h-51v365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 278,
    d: "M20 580q0 53 34 86.5t85 33.5t85 -33.5t34 -86.5q0 -52 -34 -86t-85 -34t-85 34t-34 86zM60 580q0 -36 22.5 -59t56.5 -23t56.5 23t22.5 59t-22.5 59t-56.5 23t-56.5 -23t-22.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 510,
    d: "M220 251l-150 194l50 45l190 -235l-190 -235l-50 45zM380 251l-150 194l50 45l190 -235l-190 -235l-50 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 754,
    d: "M618 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM601 0v84h-203l233 336h21v-291h66v-45h-66v-84h-51zM601 307l-119 -178h119v178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 819,
    d: "M618 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM493 2l198 212q21 22 32.5 44.5t11.5 47.5q0 28 -19 51.5t-57 23.5q-40 0 -65.5 -27.5t-25.5 -75.5h-51q0 67 38.5 109t103.5 42q46 0 74 -20t41 -49.5t13 -57.5q0 -32 -15.5 -61t-40.5 -55l-133 -136h191v-48 h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 820,
    d: "M164 274q-61 0 -97.5 34t-36.5 83h52q0 -30 23 -49.5t59 -19.5t57.5 20.5t21.5 54.5q0 39 -28 58.5t-69 19.5v45q41 0 63 21.5t22 51.5t-16 48.5t-48 18.5q-29 0 -49.5 -18t-20.5 -46h-49q0 49 33.5 79.5t85.5 30.5q54 0 85 -34t31 -78q0 -31 -19 -56.5t-52 -38.5 q36 -11 59.5 -37.5t23.5 -70.5q0 -53 -37.5 -85t-93.5 -32zM685 700h65l-520 -700h-65zM668 0v84h-203l233 336h21v-291h66v-45h-66v-84h-51zM668 307l-119 -178h119v178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 557,
    d: "M362 660q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39zM141 200q0 -64 40 -99.5t107 -35.5q50 0 85.5 23t58.5 60l65 -41q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 27.5t-78 75.5t-28.5 107q0 58 30 104 t78.5 74.5t103.5 31.5l7 120h60l20 -175h-26q-60 0 -103 -23t-66 -58.5t-23 -73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 660,
    d: "M200 945l75 40l150 -160l-45 -30zM560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 660,
    d: "M460 945l-180 -150l-45 30l150 160zM560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 660,
    d: "M330 850l-110 -95l-50 40l160 140l160 -140l-50 -40zM560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 660,
    d: "M165 812q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542 l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 660,
    d: "M375 850q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM175 850q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM560 0l-89 210h-282l-89 -210h-95l325 735 l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 660,
    d: "M228 798q0 45 31.5 72.5t70.5 27.5t70.5 -27.5t31.5 -72.5q0 -40 -26 -66.5t-60 -32.5l309 -699h-95l-89 210h-282l-89 -210h-95l309 699q-34 6 -60 32.5t-26 66.5zM279 798q0 -25 16 -39t35 -14t35 14t16 39t-16 39t-35 14t-35 -14t-16 -39zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 960,
    d: "M890 80v-80h-400v210h-261l-129 -210h-95l430 700h455v-80h-315v-200h295v-80h-295v-260h315zM278 290h212v347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 685,
    d: "M130 350q0 -81 36.5 -143t95.5 -97t128 -35q74 0 131 29t94 75v-112q-43 -38 -92.5 -57t-121.5 -20l-24 -43h9q25 0 48.5 -18.5t23.5 -55.5q0 -46 -32.5 -70t-73.5 -24q-28 0 -48.5 8.5t-41.5 29.5l34 40q14 -12 25.5 -18t30.5 -6q26 0 38 11t12 29q0 36 -50 36 q-7 0 -24.5 -3.5t-33.5 -14.5l52 102q-87 10 -156 58.5t-109.5 125.5t-40.5 173q0 78 27 144t75 114.5t111.5 75t136.5 26.5q77 0 129 -19t96 -58v-112q-37 47 -94 75.5t-131 28.5q-69 0 -128 -35t-95.5 -96.5t-36.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 550,
    d: "M150 920l75 40l150 -160l-45 -30zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 550,
    d: "M410 920l-180 -150l-45 30l150 160zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 550,
    d: "M290 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 550,
    d: "M335 845q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM135 845q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM80 700h400v-80h-315v-200h295v-80h-295v-260 h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 245,
    d: "M-8 920l76 40l150 -160l-46 -30zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 245,
    d: "M252 920l-180 -150l-44 30l150 160zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 245,
    d: "M122 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 245,
    d: "M168 825q0 23 16 39t38 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38.5t-39.5 -16.5q-22 0 -38 16.5t-16 38.5zM-32 825q0 23 16 39t38 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38.5t-39.5 -16.5q-22 0 -38 16.5t-16 38.5zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 680,
    d: "M290 0h-210v310h-75v75h75v315h210q102 0 181 -44t124 -122.5t45 -183.5t-45 -183.5t-124 -122.5t-181 -44zM305 310h-140v-225h125q79 0 138.5 32.5t93 92t33.5 140.5q0 82 -33.5 141t-93 91.5t-138.5 32.5h-125v-230h140v-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 775,
    d: "M215 792q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM610 700h85v-735l-530 556v-521h-85v735l530 -556v521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 790,
    d: "M275 920l75 40l150 -160l-45 -30zM40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350 q0 -79 34.5 -141t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 790,
    d: "M515 920l-180 -150l-45 30l150 160zM40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350 q0 -79 34.5 -141t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 790,
    d: "M395 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142z M130 350q0 -79 34.5 -141t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 790,
    d: "M230 807q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5 t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350q0 -79 34.5 -141t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36 t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 790,
    d: "M440 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM240 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM40 350q0 77 26.5 142.5t74.5 114t113 76 t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350q0 -79 34.5 -141t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98 t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 596,
    d: "M121 22l-56 56l182 177l-182 177l56 56l177 -182l177 182l56 -56l-182 -177l182 -177l-56 -56l-177 182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 790,
    d: "M40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q59 0 111 -16.5t95 -46.5l87 103l59 -40l-93 -109q45 -48 70.5 -112.5t25.5 -138.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-59 0 -112 17t-96 47l-89 -104l-58 40l94 111q-44 48 -69 111.5t-25 137.5 zM130 350q0 -53 16.5 -99.5t45.5 -82.5l352 413q-31 21 -69 32.5t-80 11.5q-76 0 -136 -36t-94.5 -98t-34.5 -141zM660 350q0 54 -16.5 101t-46.5 83l-353 -413q31 -22 69.5 -34t81.5 -12q77 0 136.5 36t94 98t34.5 141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 626,
    d: "M183 920l75 40l150 -160l-45 -30zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 626,
    d: "M443 920l-180 -150l-45 30l150 160zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 626,
    d: "M313 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 626,
    d: "M358 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM158 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM75 700h85v-470q0 -72 39 -116t114 -44t114 44 t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 561,
    d: "M410 920l-180 -150l-44 30l150 160zM461 700h95l-233 -398v-302h-85v301l-233 399h95l180 -324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 550,
    d: "M80 700h85v-140h105q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -64 -31.5 -111.5t-85 -73t-121.5 -25.5h-105v-140h-85v700zM270 480h-105v-260h105q68 0 110.5 33t42.5 97q0 65 -42.5 97.5t-110.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 565,
    d: "M342 -12q-46 0 -83 19t-64 49l49 60q23 -23 49 -37.5t55 -14.5q45 0 74.5 32t29.5 75q0 34 -17 56.5t-42.5 40.5t-51 35.5t-42.5 41t-17 57.5q0 35 17 61.5t40 51t40 53t17 67.5q0 33 -16 51.5t-41.5 26.5t-55.5 8q-57 0 -94 -31t-37 -102l1 -590h-81v610q0 54 27.5 96 t78 66t118.5 24q81 0 132.5 -36t51.5 -116q0 -41 -11 -69.5t-27.5 -49.5t-33 -39t-27.5 -37.5t-11 -44.5q0 -21 17 -36t41.5 -30t49 -34.5t41.5 -48t17 -71.5q0 -54 -26 -98t-69.5 -70t-98.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 485,
    d: "M88 680l75 40l150 -160l-45 -30zM111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80v66q-21 -37 -63 -56.5t-94 -19.5q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18 t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 485,
    d: "M408 680l-180 -150l-45 30l150 160zM111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80v66q-21 -37 -63 -56.5t-94 -19.5q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5 q-49 0 -84.5 -18t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 485,
    d: "M248 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80v66q-21 -37 -63 -56.5t-94 -19.5q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5 t-67.5 17.5q-49 0 -84.5 -18t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 485,
    d: "M83 567q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80 v66q-21 -37 -63 -56.5t-94 -19.5q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 485,
    d: "M293 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM93 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM111 352l-39 61q26 19 70 38t106 19 q79 0 128 -36.5t49 -103.5v-330h-80v66q-21 -37 -63 -56.5t-94 -19.5q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18 q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 485,
    d: "M146 630q0 45 31.5 72.5t70.5 27.5t70.5 -27.5t31.5 -72.5t-31.5 -72.5t-70.5 -27.5t-70.5 27.5t-31.5 72.5zM197 630q0 -25 16 -39t35 -14t35 14t16 39t-16 39t-35 14t-35 -14t-16 -39zM111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80v66 q-21 -37 -63 -56.5t-94 -19.5q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 825,
    d: "M208 -10q-82 0 -130 37t-48 98q0 48 25 84t69 56.5t102 20.5q31 0 58.5 -7t60.5 -24v45q0 48 -25 74t-72 26q-34 0 -70.5 -12.5t-66.5 -35.5l-39 61q77 57 176 57q64 0 103.5 -25.5t50.5 -74.5q28 47 76 73.5t105 26.5q61 0 107.5 -30t73 -83t26.5 -123q0 -16 -2 -24 h-361q4 -69 42.5 -107t103.5 -38q94 0 144 83l65 -41q-76 -117 -219 -117q-64 0 -106 25t-70 81q-14 -49 -61.5 -77.5t-117.5 -28.5zM571 400q-57 0 -94.5 -32.5t-47.5 -89.5h275q-4 56 -39.5 89t-93.5 33zM208 61q60 0 93.5 24.5t46.5 76.5l-2 36q-53 27 -116 27 q-119 0 -119 -90q0 -38 23.5 -56t73.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 478,
    d: "M111 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-23 -27 -63.5 -42t-85.5 -17l-24 -43h9q25 0 48.5 -18.5t23.5 -55.5q0 -46 -32.5 -70t-73.5 -24q-28 0 -48.5 8.5t-41.5 29.5l34 40q14 -12 25.5 -18t30.5 -6q26 0 38 11t12 29q0 36 -50 36 q-7 0 -24.5 -3.5t-33.5 -14.5l53 103q-57 9 -101 41.5t-69 82.5t-25 112q0 70 31.5 124t85.5 85t121 31q47 0 91.5 -15.5t68.5 -43.5v-100q-16 34 -60 59t-100 25q-45 0 -80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 515,
    d: "M123 690l75 40l150 -160l-45 -30zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23 t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 515,
    d: "M423 690l-180 -150l-45 30l150 160zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23 t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 515,
    d: "M263 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5 q50 0 85.5 23t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 515,
    d: "M308 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM108 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5 q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 260,
    d: "M-30 700l75 40l150 -160l-45 -30zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 260,
    d: "M290 700l-180 -150l-45 30l150 160zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 260,
    d: "M130 635l-110 -95l-50 40l160 140l160 -140l-50 -40zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 260,
    d: "M175 615q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM-25 615q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 576,
    d: "M288 -10q-69 0 -123 31t-84.5 85t-30.5 124q0 66 27 117t73.5 80.5t106.5 29.5t125 -32q-33 60 -86 121l-112 -43l-18 47l93 36q-37 39 -86 83l48 56q60 -60 107 -113l118 45l18 -47l-101 -39q85 -101 124 -184t39 -157q0 -70 -30.5 -124t-84 -85t-123.5 -31zM288 67 q46 0 81.5 21t55.5 58t20 84q0 48 -20.5 85t-56 58.5t-80.5 21.5t-80.5 -21.5t-56 -58.5t-20.5 -85q0 -47 20 -84t55.5 -58t81.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 525,
    d: "M98 567q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM370 280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v460h80 v-62q24 33 59.5 52.5t77.5 19.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 546,
    d: "M113 700l75 40l150 -160l-45 -30zM35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85 t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 546,
    d: "M433 700l-180 -150l-45 30l150 160zM35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85 t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 546,
    d: "M273 645l-110 -95l-50 40l160 140l160 -140l-50 -40zM35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5 t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 546,
    d: "M108 567q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124 q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 546,
    d: "M318 615q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM118 615q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM35 230q0 70 31.5 124t85.5 85t121 31 q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 623,
    d: "M255 450q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM60 225v80h500v-80h-500zM255 70q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 546,
    d: "M35 230q0 70 31.5 124t85.5 85t121 31t121 -31l46 61l45 -20l-52 -69q37 -32 57.5 -78.5t20.5 -102.5q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-70 0 -127 34l-51 -68l-45 20l58 78q-34 32 -53.5 77t-19.5 99zM116 230q0 -34 10.5 -62.5t28.5 -49.5l193 259 q-34 18 -75 18q-45 0 -80.5 -21t-56 -58.5t-20.5 -85.5zM430 230q0 36 -11.5 66t-32.5 51l-194 -260q36 -22 81 -22t80.5 21.5t56 58.5t20.5 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 525,
    d: "M142 700l76 40l150 -160l-46 -30zM155 180q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v62q-24 -33 -59.5 -52.5t-77.5 -19.5q-71 0 -114.5 45.5t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 525,
    d: "M382 700l-180 -150l-44 30l150 160zM155 180q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v62q-24 -33 -59.5 -52.5t-77.5 -19.5q-71 0 -114.5 45.5t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 525,
    d: "M262 645l-110 -95l-50 40l160 140l160 -140l-50 -40zM155 180q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v62q-24 -33 -59.5 -52.5t-77.5 -19.5q-71 0 -114.5 45.5t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 525,
    d: "M308 605q0 23 16 39t38 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38.5t-39.5 -16.5q-22 0 -38 16.5t-16 38.5zM108 605q0 23 16 39t38 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38.5t-39.5 -16.5q-22 0 -38 16.5t-16 38.5zM155 180q0 -115 98 -115q53 0 85 33t32 82v280 h80v-460h-80v62q-24 -33 -59.5 -52.5t-77.5 -19.5q-71 0 -114.5 45.5t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 440,
    d: "M350 700l-180 -150l-45 30l150 160zM440 460l-300 -680h-90l126 285l-176 395h95l129 -317l126 317h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    d: "M150 -220h-80v1000h80v-399q25 43 65.5 66t91.5 23q63 0 114.5 -29t82.5 -82.5t31 -128.5q0 -74 -31 -128t-82.5 -83t-114.5 -29q-51 0 -91.5 23t-65.5 66v-299zM454 230q0 53 -21.5 90t-57 56t-78.5 19q-35 0 -69 -19t-56 -56t-22 -90t22 -90t56 -56t69 -19 q43 0 78.5 19t57 56t21.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 440,
    d: "M265 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM65 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM440 460l-300 -680h-90l126 285l-176 395h95 l129 -317l126 317h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 660,
    d: "M155 795v75h350v-75h-350zM560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 485,
    d: "M73 550v75h350v-75h-350zM111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80v66q-21 -37 -63 -56.5t-94 -19.5q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18 t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 660,
    d: "M172 935h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 485,
    d: "M90 670h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80v66q-21 -37 -63 -56.5t-94 -19.5 q-71 0 -114.5 36t-43.5 99q0 54 26 89.5t70.5 53.5t99.5 18q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18t-52.5 -30zM111 135q0 -74 97 -74q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 660,
    d: "M660 -130l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 35 25.5 65t63.5 55h-11l-89 210h-282l-89 -210h-95l325 735l325 -735q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 485,
    d: "M111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 36 27 67t66 56v63q-21 -37 -63 -56.5t-94 -19.5q-43 0 -79 16 t-57.5 47.5t-21.5 78.5q0 73 52.5 113.5t143.5 40.5q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18t-52.5 -30zM111 135q0 -37 28.5 -55.5t68.5 -18.5q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 685,
    d: "M520 920l-180 -150l-45 30l150 160zM130 350q0 -81 36.5 -143t95.5 -97t128 -35q74 0 131 29t94 75v-112q-44 -39 -96 -58t-129 -19q-73 0 -136.5 26.5t-111.5 75t-75 114.5t-27 144t27 144t75 114.5t111.5 75t136.5 26.5q77 0 129 -19t96 -58v-112q-37 47 -94 75.5 t-131 28.5q-69 0 -128 -35t-95.5 -96.5t-36.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 478,
    d: "M398 680l-180 -150l-45 30l150 160zM111 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-24 -28 -68.5 -43.5t-91.5 -15.5q-67 0 -121 31t-85.5 85.5t-31.5 123.5q0 70 31.5 124t85.5 85t121 31q47 0 91.5 -15.5t68.5 -43.5v-100q-16 34 -60 59 t-100 25q-45 0 -80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 685,
    d: "M390 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM130 350q0 -81 36.5 -143t95.5 -97t128 -35q74 0 131 29t94 75v-112q-44 -39 -96 -58t-129 -19q-73 0 -136.5 26.5t-111.5 75t-75 114.5t-27 144t27 144t75 114.5t111.5 75t136.5 26.5q77 0 129 -19t96 -58v-112 q-37 47 -94 75.5t-131 28.5q-69 0 -128 -35t-95.5 -96.5t-36.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 478,
    d: "M268 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM111 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-24 -28 -68.5 -43.5t-91.5 -15.5q-67 0 -121 31t-85.5 85.5t-31.5 123.5q0 70 31.5 124t85.5 85t121 31q47 0 91.5 -15.5t68.5 -43.5v-100 q-16 34 -60 59t-100 25q-45 0 -80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 685,
    d: "M335 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM130 350q0 -81 36.5 -143t95.5 -97t128 -35q74 0 131 29t94 75v-112q-44 -39 -96 -58t-129 -19q-73 0 -136.5 26.5t-111.5 75t-75 114.5t-27 144t27 144 t75 114.5t111.5 75t136.5 26.5q77 0 129 -19t96 -58v-112q-37 47 -94 75.5t-131 28.5q-69 0 -128 -35t-95.5 -96.5t-36.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 478,
    d: "M213 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM111 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-24 -28 -68.5 -43.5t-91.5 -15.5q-67 0 -121 31t-85.5 85.5t-31.5 123.5 q0 70 31.5 124t85.5 85t121 31q47 0 91.5 -15.5t68.5 -43.5v-100q-16 34 -60 59t-100 25q-45 0 -80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 685,
    d: "M390 855l110 95l50 -40l-160 -140l-160 140l50 40zM130 350q0 -81 36.5 -143t95.5 -97t128 -35q74 0 131 29t94 75v-112q-44 -39 -96 -58t-129 -19q-73 0 -136.5 26.5t-111.5 75t-75 114.5t-27 144t27 144t75 114.5t111.5 75t136.5 26.5q77 0 129 -19t96 -58v-112 q-37 47 -94 75.5t-131 28.5q-69 0 -128 -35t-95.5 -96.5t-36.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 478,
    d: "M268 615l110 95l50 -40l-160 -140l-160 140l50 40zM111 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-24 -28 -68.5 -43.5t-91.5 -15.5q-67 0 -121 31t-85.5 85.5t-31.5 123.5q0 70 31.5 124t85.5 85t121 31q47 0 91.5 -15.5t68.5 -43.5v-100 q-16 34 -60 59t-100 25q-45 0 -80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 680,
    d: "M330 855l110 95l50 -40l-160 -140l-160 140l50 40zM290 0h-210v700h210q102 0 181 -44t124 -122.5t45 -183.5t-45 -183.5t-124 -122.5t-181 -44zM290 615h-125v-530h125q79 0 138.5 32.5t93 92t33.5 140.5q0 82 -33.5 141t-93 91.5t-138.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    d: "M35 230q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v399h80v-780h-80v79q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128zM618 780l80 -30l-110 -250l-58 21zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56 t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 680,
    d: "M290 0h-210v310h-75v75h75v315h210q102 0 181 -44t124 -122.5t45 -183.5t-45 -183.5t-124 -122.5t-181 -44zM305 310h-140v-225h125q79 0 138.5 32.5t93 92t33.5 140.5q0 82 -33.5 141t-93 91.5t-138.5 32.5h-125v-230h140v-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M35 230q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v209h-125v75h125v115h80v-115h95v-75h-95v-590h-80v79q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19 q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 550,
    d: "M105 770v75h350v-75h-350zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 515,
    d: "M88 530v75h350v-75h-350zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23t58.5 60z M263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 550,
    d: "M122 910h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 515,
    d: "M105 670h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100 t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 550,
    d: "M225 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 515,
    d: "M208 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29 t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 550,
    d: "M365 -130l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 35 25.5 65t63.5 55h-196v700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-120q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 515,
    d: "M299 -131l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 34 23.5 63t59.5 53q-50 12 -88 44.5t-59.5 81.5t-21.5 109q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5 q50 0 85.5 23t58.5 60l65 -41q-32 -49 -75 -80.5t-121 -35.5q-32 -18 -53.5 -42.5t-21.5 -49.5q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 550,
    d: "M280 855l110 95l50 -40l-160 -140l-160 140l50 40zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 515,
    d: "M263 615l110 95l50 -40l-160 -140l-160 140l50 40zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5 q50 0 85.5 23t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 775,
    d: "M395 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM405 275v80h325q0 -73 -22 -138.5t-65 -116.5t-105.5 -80.5t-142.5 -29.5q-76 0 -141 26.5t-113 75t-74.5 114.5t-26.5 144t26.5 144t74.5 114.5t113 75t141 26.5q97 0 171.5 -38t119.5 -111l-60 -55q-33 56 -92 87.5 t-139 31.5q-74 0 -134 -35t-95.5 -96.5t-35.5 -143.5q0 -81 35.5 -143t95.5 -97t134 -35q70 0 120 27.5t81 73t42 99.5h-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    d: "M263 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM44 -30h81q0 -33 18 -61.5t51 -46t78 -17.5q35 0 69 17t56.5 53.5t22.5 94.5v69q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v79h80v-450 q0 -79 -33 -132.5t-85 -80.5t-110 -27q-67 0 -118.5 25t-80.5 70.5t-29 104.5zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 775,
    d: "M237 910h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM405 275v80h325q0 -73 -22 -138.5t-65 -116.5t-105.5 -80.5t-142.5 -29.5q-76 0 -141 26.5t-113 75t-74.5 114.5 t-26.5 144t26.5 144t74.5 114.5t113 75t141 26.5q97 0 171.5 -38t119.5 -111l-60 -55q-33 56 -92 87.5t-139 31.5q-74 0 -134 -35t-95.5 -96.5t-35.5 -143.5q0 -81 35.5 -143t95.5 -97t134 -35q70 0 120 27.5t81 73t42 99.5h-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    d: "M105 670h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM44 -30h81q0 -33 18 -61.5t51 -46t78 -17.5q35 0 69 17t56.5 53.5t22.5 94.5v69q-25 -43 -65.5 -66t-91.5 -23 q-62 0 -114 29t-83 83t-31 128q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v79h80v-450q0 -79 -33 -132.5t-85 -80.5t-110 -27q-67 0 -118.5 25t-80.5 70.5t-29 104.5zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19 q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 775,
    d: "M340 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM405 275v80h325q0 -73 -22 -138.5t-65 -116.5t-105.5 -80.5t-142.5 -29.5q-76 0 -141 26.5t-113 75t-74.5 114.5t-26.5 144t26.5 144t74.5 114.5t113 75 t141 26.5q97 0 171.5 -38t119.5 -111l-60 -55q-33 56 -92 87.5t-139 31.5q-74 0 -134 -35t-95.5 -96.5t-35.5 -143.5q0 -81 35.5 -143t95.5 -97t134 -35q70 0 120 27.5t81 73t42 99.5h-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    d: "M228 625q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM44 -30h81q0 -33 18 -61.5t51 -46t78 -17.5q35 0 69 17t56.5 53.5t22.5 94.5v69q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128q0 75 31 128.5 t83 82.5t114 29q51 0 91.5 -23t65.5 -66v79h80v-450q0 -79 -33 -132.5t-85 -80.5t-110 -27q-67 0 -118.5 25t-80.5 70.5t-29 104.5zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 775,
    d: "M405 275v80h325q0 -73 -22 -138.5t-65 -116.5t-105.5 -80.5t-142.5 -29.5q-76 0 -141 26.5t-113 75t-74.5 114.5t-26.5 144t26.5 144t74.5 114.5t113 75t141 26.5q97 0 171.5 -38t119.5 -111l-60 -55q-33 56 -92 87.5t-139 31.5q-74 0 -134 -35t-95.5 -96.5t-35.5 -143.5 q0 -81 35.5 -143t95.5 -97t134 -35q70 0 120 27.5t81 73t42 99.5h-233zM399 -70l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    d: "M282 546l-74 42l147 230l54 -30zM44 -30h81q0 -33 18 -61.5t51 -46t78 -17.5q35 0 69 17t56.5 53.5t22.5 94.5v69q-25 -43 -65.5 -66t-91.5 -23q-62 0 -114 29t-83 83t-31 128q0 75 31 128.5t83 82.5t114 29q51 0 91.5 -23t65.5 -66v79h80v-450q0 -79 -33 -132.5 t-85 -80.5t-110 -27q-67 0 -118.5 25t-80.5 70.5t-29 104.5zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 715,
    d: "M358 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM80 700h85v-280h385v280h85v-700h-85v340h-385v-340h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 525,
    d: "M122 935l-110 -95l-50 40l160 140l160 -140l-50 -40zM370 280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v780h80v-382q24 33 59.5 52.5t77.5 19.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 715,
    d: "M5 540v75h75v85h85v-85h385v85h85v-85h75v-75h-75v-540h-85v340h-385v-340h-85v540h-75zM165 420h385v120h-385v-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 525,
    d: "M370 280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v625h-70v75h70v80h80v-80h162v-75h-162v-238q21 38 56.5 60.5t80.5 22.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 245,
    d: "M-42 807q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 260,
    d: "M-35 567q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 245,
    d: "M-52 770v75h350v-75h-350zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 260,
    d: "M-45 530v75h350v-75h-350zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 245,
    d: "M-35 910h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 260,
    d: "M-28 670h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 245,
    d: "M170 -130l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 35 25.5 65t63.5 55h-1v700h85v-700q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 260,
    d: "M75 650q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM175 -130l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 36 27 67t66 56v457h80v-460q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5 q20 0 30 5t20 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 245,
    d: "M67 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 260,
    d: "M90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 490,
    d: "M183 -104q22 -36 79 -36q23 0 45.5 20.5t22.5 69.5v750h80v-760q0 -82 -41 -121t-112 -39q-40 0 -73.5 17.5t-44.5 32.5zM80 700h85v-700h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 510,
    d: "M325 650q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM75 650q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM243 -114q11 -17 24 -21.5t25 -4.5 q23 0 35.5 20.5t12.5 69.5v510h80v-520q0 -82 -35 -121t-98 -39q-32 0 -54.5 12.5t-33.5 27.5zM90 460h80v-460h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 240,
    d: "M120 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM-67 -104q22 -36 79 -36q23 0 45.5 20.5t22.5 69.5v750h80v-760q0 -82 -41 -121t-112 -39q-40 0 -73.5 17.5t-44.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 250,
    d: "M120 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM-17 -114q11 -17 24 -21.5t25 -4.5q23 0 35.5 20.5t12.5 69.5v510h80v-520q0 -82 -35 -121t-98 -39q-32 0 -54.5 12.5t-33.5 27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 565,
    d: "M80 700h85v-301l275 301h105l-303 -328l318 -372h-105l-290 340v-340h-85v700zM324 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 440,
    d: "M320 460h100l-200 -190l220 -270h-100l-190 233v-233h-80v780h80v-481zM259 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 440,
    d: "M70 460h80v-161l170 161h100l-200 -190l220 -270h-100l-190 233v-233h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 450,
    d: "M390 920l-180 -150l-45 30l150 160zM80 700h85v-620h275v-80h-360v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 230,
    d: "M245 990l-180 -150l-45 30l150 160zM75 780h80v-780h-80v780z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 450,
    d: "M80 700h85v-620h275v-80h-360v700zM264 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 230,
    d: "M75 780h80v-780h-80v780zM119 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 450,
    d: "M328 710l80 -30l-110 -250l-58 21zM80 700h85v-620h275v-80h-360v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 230,
    d: "M75 780h80v-780h-80v780zM293 780l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 450,
    d: "M80 700h85v-620h275v-80h-360v700zM255 415q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 370,
    d: "M75 780h80v-780h-80v780zM215 415q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 450,
    d: "M5 340l-20 55l95 60v245h85v-192l90 57l20 -55l-110 -69v-361h275v-80h-360v387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 230,
    d: "M5 340l-20 55l90 54v331h80v-283l80 48l20 -55l-100 -60v-430h-80v382z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 775,
    d: "M560 905l-180 -150l-45 30l150 160zM610 700h85v-735l-530 556v-521h-85v735l530 -556v521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 525,
    d: "M402 680l-180 -150l-44 30l150 160zM370 280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v460h80v-73q21 38 56.5 60.5t80.5 22.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 775,
    d: "M610 700h85v-735l-530 556v-521h-85v735l530 -556v521zM399 -35l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    horizAdvX: 525,
    d: "M370 280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v460h80v-62q24 33 59.5 52.5t77.5 19.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280zM266 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 775,
    d: "M400 880l110 95l50 -40l-160 -140l-160 140l50 40zM610 700h85v-735l-530 556v-521h-85v735l530 -556v521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 525,
    d: "M262 615l110 95l50 -40l-160 -140l-160 140l50 40zM370 280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v460h80v-62q24 33 59.5 52.5t77.5 19.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 635,
    d: "M130 700h95l-100 -230h-55zM265 460v-62q24 33 59.5 52.5t77.5 19.5q71 0 114.5 -45.5t43.5 -134.5v-290h-80v280q0 115 -98 115q-52 0 -84.5 -32.5t-32.5 -82.5v-280h-80v460h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 775,
    d: "M562 -220q-58 0 -88 40l44 66q16 -26 49 -26q26 0 37 21t11 69v99l-450 472v-521h-85v735l530 -556v521h85v-760q0 -76 -35 -118t-98 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 525,
    d: "M317 -220q-27 0 -50.5 10.5t-37.5 29.5l44 66q16 -26 49 -26q48 0 48 90v330q0 115 -98 115q-51 0 -84 -32t-33 -83v-280h-80v460h80v-72q23 39 58.5 60.5t78.5 21.5q75 0 116.5 -47t41.5 -133v-350q0 -160 -133 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 790,
    d: "M220 770v75h350v-75h-350zM40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350q0 -79 34.5 -141 t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 546,
    d: "M98 530v75h350v-75h-350zM35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5 t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 790,
    d: "M237 910h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5 q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350q0 -79 34.5 -141t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 546,
    d: "M115 670h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31 q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 790,
    d: "M313 770l-52 17l104 194l82 -20zM477 770l-51 17l103 194l84 -20zM40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5 t-26.5 142zM130 350q0 -79 34.5 -141t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 546,
    d: "M191 530l-52 17l104 194l82 -20zM355 530l-51 17l103 194l84 -20zM35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5 t80.5 21.5t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 985,
    d: "M916 80v-80h-526q-101 0 -180.5 44t-124.5 122.5t-45 183.5t45 183.5t124 122.5t181 44h525v-80h-315v-200h295v-80h-295v-260h316zM390 80h125v540h-125q-79 0 -138.5 -33.5t-93 -94t-33.5 -142.5q0 -81 33.5 -142t93.5 -94.5t138 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 900,
    d: "M35 230q0 75 31 128.5t83 82.5t114 29q69 0 117.5 -35.5t69.5 -99.5q26 62 80.5 98.5t127.5 36.5q55 0 102 -29t76 -81.5t29 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23t58.5 60l65 -41q-34 -52 -84.5 -84.5t-124.5 -32.5q-68 0 -120 36.5t-78 97.5 q-21 -63 -69.5 -98.5t-117.5 -35.5q-62 0 -114 29t-83 83t-31 128zM648 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 66.5 19t51 56t19.5 90t-19.5 90t-51 56t-66.5 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 560,
    d: "M405 920l-180 -150l-45 30l150 160zM80 700h190q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -79 -46.5 -131.5t-120.5 -70.5l209 -288h-105l-195 280h-85v-280h-85v700zM270 625h-105v-270h105q68 0 110.5 35.5t42.5 99.5q0 65 -42.5 100t-110.5 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 343,
    d: "M336 680l-180 -150l-44 30l150 160zM294 372q-16 12 -29 17.5t-33 5.5q-45 0 -61 -32.5t-16 -82.5v-280h-80v460h80v-53q19 29 45 46t52 17q25 0 46.5 -6.5t39.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 560,
    d: "M80 700h190q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -79 -46.5 -131.5t-120.5 -70.5l209 -288h-105l-195 280h-85v-280h-85v700zM270 625h-105v-270h105q68 0 110.5 35.5t42.5 99.5q0 65 -42.5 100t-110.5 35zM319 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 343,
    d: "M294 372q-16 12 -29 17.5t-33 5.5q-45 0 -61 -32.5t-16 -82.5v-280h-80v460h80v-53q19 29 45 46t52 17q25 0 46.5 -6.5t39.5 -25.5zM119 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 560,
    d: "M255 855l110 95l50 -40l-160 -140l-160 140l50 40zM80 700h190q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -79 -46.5 -131.5t-120.5 -70.5l209 -288h-105l-195 280h-85v-280h-85v700zM270 625h-105v-270h105q68 0 110.5 35.5t42.5 99.5q0 65 -42.5 100t-110.5 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 343,
    d: "M206 615l110 95l50 -40l-160 -140l-160 140l50 40zM294 372q-16 12 -29 17.5t-33 5.5q-45 0 -61 -32.5t-16 -82.5v-280h-80v460h80v-53q19 29 45 46t52 17q25 0 46.5 -6.5t39.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 548,
    d: "M458 920l-180 -150l-45 30l150 160zM112 226q32 -72 75 -114t108 -42q60 0 90 30.5t30 82.5q0 45 -24.5 74t-62 48t-77.5 33q-26 9 -56.5 24.5t-57.5 38.5t-44.5 56t-17.5 78q0 53 27 92.5t73 61t103 21.5t100 -22.5t72.5 -57t43.5 -70.5l-69 -46q-15 29 -34 55.5t-46 43 t-66 16.5q-52 0 -83.5 -27t-31.5 -73q0 -34 23 -57.5t60 -41.5t79 -34q27 -10 58 -26t58 -39.5t44 -58t17 -82.5q0 -89 -54.5 -144.5t-158.5 -55.5q-86 0 -151.5 53.5t-98.5 139.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 403,
    d: "M383 680l-180 -150l-45 30l150 160zM91 161q9 -42 42.5 -69t76.5 -27q38 0 59 14t21 44q0 25 -15 41.5t-38.5 28.5t-50.5 22q-31 13 -61.5 29t-50.5 41.5t-20 63.5t22 65t56 41.5t71 14.5t71.5 -12t60 -32t34.5 -46l-64 -41q-16 23 -44.5 39t-56.5 16q-30 0 -50 -11.5 t-20 -38.5q0 -18 17.5 -31.5t43.5 -24.5t51 -22q33 -13 62 -32t47 -44.5t18 -59.5q0 -74 -47 -107t-121 -33q-42 0 -81 17.5t-65.5 48t-33.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 548,
    d: "M278 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM112 226q32 -72 75 -114t108 -42q60 0 90 30.5t30 82.5q0 45 -24.5 74t-62 48t-77.5 33q-26 9 -56.5 24.5t-57.5 38.5t-44.5 56t-17.5 78q0 53 27 92.5t73 61t103 21.5t100 -22.5t72.5 -57t43.5 -70.5l-69 -46 q-15 29 -34 55.5t-46 43t-66 16.5q-52 0 -83.5 -27t-31.5 -73q0 -34 23 -57.5t60 -41.5t79 -34q27 -10 58 -26t58 -39.5t44 -58t17 -82.5q0 -89 -54.5 -144.5t-158.5 -55.5q-86 0 -151.5 53.5t-98.5 139.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 403,
    d: "M203 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM91 161q9 -42 42.5 -69t76.5 -27q38 0 59 14t21 44q0 25 -15 41.5t-38.5 28.5t-50.5 22q-31 13 -61.5 29t-50.5 41.5t-20 63.5t22 65t56 41.5t71 14.5t71.5 -12t60 -32t34.5 -46l-64 -41q-16 23 -44.5 39t-56.5 16 q-30 0 -50 -11.5t-20 -38.5q0 -18 17.5 -31.5t43.5 -24.5t51 -22q33 -13 62 -32t47 -44.5t18 -59.5q0 -74 -47 -107t-121 -33q-42 0 -81 17.5t-65.5 48t-33.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 548,
    d: "M112 226q32 -72 75 -114t108 -42q60 0 90 30.5t30 82.5q0 45 -24.5 74t-62 48t-77.5 33q-26 9 -56.5 22.5t-57.5 34.5t-44.5 54t-17.5 81q0 53 25 93.5t70.5 63.5t107.5 23q57 0 98.5 -20.5t70.5 -54.5t47 -75l-69 -46q-15 29 -36.5 55.5t-51 43t-68.5 16.5 q-52 0 -78.5 -27t-26.5 -73q0 -34 23 -57.5t60 -41.5t79 -34q27 -10 58 -26t58 -39.5t44 -58t17 -82.5q0 -82 -49 -135.5t-132 -62.5l-25 -45h9q25 0 48.5 -18.5t23.5 -55.5q0 -46 -32.5 -70t-73.5 -24q-28 0 -48.5 8.5t-41.5 29.5l34 40q14 -12 25.5 -18t30.5 -6 q26 0 38 11t12 29q0 36 -50 36q-7 0 -24.5 -3.5t-33.5 -14.5l51 100q-77 8 -135.5 60t-89.5 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 403,
    d: "M88 163q24 -42 59 -69.5t68 -27.5q32 0 53.5 13.5t21.5 42.5q0 24 -15 40t-38.5 28t-50.5 22q-31 13 -61.5 27.5t-50.5 39.5t-20 68t22 70.5t56 40.5t71 13q55 0 100 -26t66 -64l-64 -41q-16 23 -44.5 40.5t-56.5 17.5q-30 0 -51 -10.5t-21 -37.5q0 -22 18 -35.5 t44.5 -23t51.5 -20.5q33 -13 62 -31t47 -44t18 -65q0 -65 -35.5 -98t-89.5 -40l-26 -45h8q25 0 49.5 -18.5t24.5 -55.5q0 -46 -33.5 -70t-74.5 -24q-28 0 -47.5 8.5t-40.5 29.5l32 40q14 -12 25.5 -18t30.5 -6q26 0 38 11t12 29q0 36 -50 36q-7 0 -23.5 -3.5t-32.5 -14.5 l50 101q-55 7 -98.5 43.5t-66.5 87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 548,
    d: "M278 855l110 95l50 -40l-160 -140l-160 140l50 40zM112 226q32 -72 75 -114t108 -42q60 0 90 30.5t30 82.5q0 45 -24.5 74t-62 48t-77.5 33q-26 9 -56.5 24.5t-57.5 38.5t-44.5 56t-17.5 78q0 53 27 92.5t73 61t103 21.5t100 -22.5t72.5 -57t43.5 -70.5l-69 -46 q-15 29 -34 55.5t-46 43t-66 16.5q-52 0 -83.5 -27t-31.5 -73q0 -34 23 -57.5t60 -41.5t79 -34q27 -10 58 -26t58 -39.5t44 -58t17 -82.5q0 -89 -54.5 -144.5t-158.5 -55.5q-86 0 -151.5 53.5t-98.5 139.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 403,
    d: "M203 615l110 95l50 -40l-160 -140l-160 140l50 40zM91 161q9 -42 42.5 -69t76.5 -27q38 0 59 14t21 44q0 25 -15 41.5t-38.5 28.5t-50.5 22q-31 13 -61.5 29t-50.5 41.5t-20 63.5t22 65t56 41.5t71 14.5t71.5 -12t60 -32t34.5 -46l-64 -41q-16 23 -44.5 39t-56.5 16 q-30 0 -50 -11.5t-20 -38.5q0 -18 17.5 -31.5t43.5 -24.5t51 -22q33 -13 62 -32t47 -44.5t18 -59.5q0 -74 -47 -107t-121 -33q-42 0 -81 17.5t-65.5 48t-33.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 465,
    d: "M202 9h61l-64 -112h9q25 0 49 -18.5t24 -55.5q0 -46 -33 -70t-74 -24q-28 0 -48 8.5t-41 29.5l33 40q14 -12 25.5 -18t30.5 -6q26 0 38 11t12 29q0 36 -50 36q-7 0 -24 -3.5t-33 -14.5zM10 620v80h445v-80h-180v-620h-85v620h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 240,
    d: "M90 9h61l-64 -112h9q25 0 49 -18.5t24 -55.5q0 -46 -33 -70t-74 -24q-28 0 -48 8.5t-41 29.5l33 40q14 -12 25.5 -18t30.5 -6q26 0 38 11t12 29q0 36 -50 36q-7 0 -24 -3.5t-33 -14.5zM5 460h75v160h80v-160h75v-75h-75v-385h-80v385h-75v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 465,
    d: "M233 855l110 95l50 -40l-160 -140l-160 140l50 40zM10 620v80h445v-80h-180v-620h-85v620h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 350,
    d: "M295 810l80 -30l-110 -250l-58 21zM5 460h75v160h80v-160h75v-75h-75v-385h-80v385h-75v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 465,
    d: "M74.875 380v75h315.003v-75h-315.003zM10 620v80h445v-80h-180v-620h-85v620h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 240,
    d: "M20 205v75h200v-75h-200zM5 460h75v160h80v-160h75v-75h-75v-385h-80v385h-75v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 626,
    d: "M148 807q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470 q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 525,
    d: "M98 567q7 37 38.5 59.5t65.5 22.5q24 0 39 -7t26.5 -16.5t24.5 -16.5t34 -7q26 0 56 48l46 -43q-12 -28 -40.5 -50.5t-65.5 -22.5q-28 0 -46.5 12t-35.5 23.5t-39 11.5q-21 0 -32 -9.5t-14.5 -21.5t-3.5 -20zM155 180q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80 v73q-21 -38 -56.5 -60.5t-80.5 -22.5q-71 0 -114.5 45.5t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 626,
    d: "M138 770v75h350v-75h-350zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 525,
    d: "M88 530v75h350v-75h-350zM155 180q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v73q-21 -38 -56.5 -60.5t-80.5 -22.5q-71 0 -114.5 45.5t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 626,
    d: "M155 910h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31 q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 525,
    d: "M105 670h71q0 -13 7 -30.5t26 -31t54 -13.5t53.5 13.5t26 31t7.5 30.5h71q0 -34 -18 -66.5t-53 -53t-87 -20.5q-53 0 -88 20.5t-52.5 53t-17.5 66.5zM155 180q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v73q-21 -38 -56.5 -60.5t-80.5 -22.5q-71 0 -114.5 45.5 t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 626,
    d: "M211 870q0 45 31.5 72.5t70.5 27.5t70.5 -27.5t31.5 -72.5t-31.5 -72.5t-70.5 -27.5t-70.5 27.5t-31.5 72.5zM262 870q0 -25 16 -39t35 -14t35 14t16 39t-16 39t-35 14t-35 -14t-16 -39zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470 q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 525,
    d: "M161 630q0 45 31.5 72.5t70.5 27.5t70.5 -27.5t31.5 -72.5t-31.5 -72.5t-70.5 -27.5t-70.5 27.5t-31.5 72.5zM212 630q0 -25 16 -39t35 -14q18 0 34.5 14t16.5 39t-16.5 39t-34.5 14q-19 0 -35 -14t-16 -39zM155 180q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v73 q-21 -38 -56.5 -60.5t-80.5 -22.5q-71 0 -114.5 45.5t-43.5 134.5v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 626,
    d: "M231 770l-52 17l104 194l82 -20zM395 770l-51 17l103 194l84 -20zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 525,
    d: "M181 530l-52 17l104 194l82 -20zM345 530l-51 17l103 194l84 -20zM155 180q0 -55 25 -85t73 -30q53 0 85 32t32 83v280h80v-460h-80v72q-46 -82 -137 -82q-72 0 -115 49t-43 131v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 626,
    d: "M357 -134l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 30 18.5 56t48.5 48.5t65 40.5l41 -25q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15zM75 700h85v-470q0 -72 39 -116t114 -44t114 44t39 116v470h85v-470 q0 -69 -29.5 -123.5t-82.5 -85.5t-126 -31q-72 0 -125.5 31t-83 85.5t-29.5 123.5v470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 525,
    d: "M279 -127l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 30 18.5 56t48.5 48.5t65 40.5l41 -25q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15zM155 180q0 -55 25 -85t73 -30q53 0 85 32t32 83v280h80v-460h-80v72 q-46 -82 -137 -82q-72 0 -115 49t-43 131v290h80v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 990,
    d: "M495 890l-110 -95l-50 40l160 140l160 -140l-50 -40zM700 175l185 525h95l-275 -735l-210 544l-210 -544l-275 735h95l185 -525l205 560z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 680,
    d: "M335 650l-110 -95l-50 40l160 140l160 -140l-50 -40zM5 460h90l115 -299l125 334l134 -336l116 301h90l-200 -495l-139 335l-131 -335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 561,
    d: "M281 865l-110 -95l-50 40l160 140l160 -140l-50 -40zM461 700h95l-233 -398v-302h-85v301l-233 399h95l180 -324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 440,
    d: "M220 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM440 460l-300 -680h-90l126 285l-176 395h95l129 -317l126 317h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 561,
    d: "M126 825q0 23 16 39t38 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38.5t-39.5 -16.5q-22 0 -38 16.5t-16 38.5zM326 825q0 23 16 39t38 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38.5t-39.5 -16.5q-22 0 -38 16.5t-16 38.5zM461 700h95l-233 -398v-302h-85v301l-233 399 h95l180 -324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 545,
    d: "M440 920l-180 -150l-45 30l150 160zM35 620v80h490l-368 -620h348v-80h-490l368 620h-348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 460,
    d: "M405 700l-180 -150l-45 30l150 160zM300 385h-255v75h400l-285 -385h265v-75h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 545,
    d: "M225 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM35 620v80h490l-368 -620h348v-80h-490l368 620h-348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 460,
    d: "M190 615q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM300 385h-255v75h400l-285 -385h265v-75h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 545,
    d: "M280 855l110 95l50 -40l-160 -140l-160 140l50 40zM35 620v80h490l-368 -620h348v-80h-490l368 620h-348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 460,
    d: "M245 615l110 95l50 -40l-160 -140l-160 140l50 40zM300 385h-255v75h400l-285 -385h265v-75h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 600,
    d: "M204 -200q-22 1 -42.5 10.5t-46.5 31.5l43 62q16 -15 25.5 -20.5t18.5 -5.5q46 0 52 90l24 417h-62l6 75h60l9 166q5 77 40 121t91 42q23 -1 43.5 -10t45.5 -32l-43 -62q-16 15 -25.5 20.5t-18.5 5.5q-22 0 -35.5 -23.5t-16.5 -67.5l-10 -160h80l-6 -75h-78l-23 -423 q-4 -76 -39.5 -119.5t-91.5 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0212",
    unicode: "\u0212",
    horizAdvX: 560,
    d: "M117 770q0 35 17.5 67t53 52.5t87.5 20.5q53 0 88 -20.5t52.5 -52.5t17.5 -67h-71q0 13 -7 30.5t-26 31t-54 13.5t-54 -13.5t-26 -31t-7 -30.5h-71zM80 700h190q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -79 -46.5 -131.5t-120.5 -70.5l209 -288h-105l-195 280h-85v-280 h-85v700zM270 625h-105v-270h105q68 0 110.5 35.5t42.5 99.5q0 65 -42.5 100t-110.5 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0213",
    unicode: "\u0213",
    horizAdvX: 343,
    d: "M49 530q0 35 17.5 67t53 52.5t87.5 20.5q53 0 88 -20.5t52.5 -52.5t17.5 -67h-71q0 13 -7 30.5t-26 31t-54 13.5t-54 -13.5t-26 -31t-7 -30.5h-71zM294 372q-16 12 -29 17.5t-33 5.5q-45 0 -61 -32.5t-16 -82.5v-280h-80v460h80v-53q19 29 45 46t52 17q25 0 46.5 -6.5 t39.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 548,
    d: "M112 226q32 -72 75 -114t108 -42q60 0 90 30.5t30 82.5q0 45 -24.5 74t-62 48t-77.5 33q-26 9 -56.5 24.5t-57.5 38.5t-44.5 56t-17.5 78q0 53 27 92.5t73 61t103 21.5t100 -22.5t72.5 -57t43.5 -70.5l-69 -46q-15 29 -34 55.5t-46 43t-66 16.5q-52 0 -83.5 -27 t-31.5 -73q0 -34 23 -57.5t60 -41.5t79 -34q27 -10 58 -26t58 -39.5t44 -58t17 -82.5q0 -89 -54.5 -144.5t-158.5 -55.5q-86 0 -151.5 53.5t-98.5 139.5zM294 -70l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 403,
    d: "M91 161q9 -42 42.5 -69t76.5 -27q38 0 59 14t21 44q0 25 -15 41.5t-38.5 28.5t-50.5 22q-31 13 -61.5 29t-50.5 41.5t-20 63.5t22 65t56 41.5t71 14.5t71.5 -12t60 -32t34.5 -46l-64 -41q-16 23 -44.5 39t-56.5 16q-30 0 -50 -11.5t-20 -38.5q0 -18 17.5 -31.5 t43.5 -24.5t51 -22q33 -13 62 -32t47 -44.5t18 -59.5q0 -74 -47 -107t-121 -33q-42 0 -81 17.5t-65.5 48t-33.5 67.5zM209 -70l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 465,
    d: "M10 620v80h445v-80h-180v-620h-85v620h-180zM237 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 240,
    d: "M5 460h75v160h80v-160h75v-75h-75v-385h-80v385h-75v75zM124 -60l80 -30l-110 -250l-58 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 250,
    d: "M-17 -114q11 -17 24 -21.5t25 -4.5q23 0 35.5 20.5t12.5 69.5v510h80v-520q0 -82 -35 -121t-98 -39q-32 0 -54.5 12.5t-33.5 27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 480,
    d: "M240 645l-110 -95l-50 40l160 140l160 -140l-50 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 480,
    d: "M240 655l110 95l50 -40l-160 -140l-160 140l50 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 546,
    d: "M115 850h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 300,
    d: "M95 790q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 278,
    d: "M37 785q0 45 31.5 72.5t70.5 27.5t70.5 -27.5t31.5 -72.5t-31.5 -72.5t-70.5 -27.5t-70.5 27.5t-31.5 72.5zM88 785q0 -25 16 -39t35 -14t35 14t16 39t-16 39t-35 14t-35 -14t-16 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 260,
    d: "M194 -130l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 30 18.5 56t48.5 48.5t65 40.5l41 -25q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 530,
    d: "M100 625q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 0,
    d: "M52 511l-52 17l104 194l82 -20zM216 511l-51 17l103 194l84 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M180 545l-180 150l75 40l150 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M60 545l-45 30l150 160l75 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M41 547l-41 49l151 130l151 -130l-41 -49l-110 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M53 588l-53 37q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M0 600v75h350v-75h-350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M158 540q-46 0 -81.5 18t-56 50t-20.5 72h71q0 -32 25 -53.5t62 -21.5q38 0 62.5 21.5t24.5 53.5h71q0 -40 -20.5 -72t-56 -50t-81.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M55 570q-22 0 -38.5 16.5t-16.5 38.5q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M55 605q-25 0 -40 15t-15 40t15 40t40 15t40 -15t15 -40t-15 -40t-40 -15zM255 605q-25 0 -40 15t-15 40t15 40t40 15t40 -15t15 -40t-15 -40t-40 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M112 520q-46 0 -79 32t-33 78t33 78t79 32q31 0 56.5 -15t41 -39.5t15.5 -55.5q0 -30 -15.5 -55t-41 -40t-56.5 -15zM112 572q23 0 39.5 17t16.5 41t-16.5 41t-39.5 17t-39.5 -17t-16.5 -41t16.5 -41t39.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M52 511l-52 17l104 194l82 -20zM216 511l-51 17l103 194l84 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M151 547l-151 131l41 48l110 -94l110 94l41 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0312",
    unicode: "\u0312",
    horizAdvX: 0,
    d: "M80 500l-80 30l110 250l58 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M40 -220l-40 23l98 180l56 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\u0327",
    horizAdvX: 0,
    d: "M89 -220q-28 0 -48 6.5t-41 21.5l23 45q21 -12 34 -15.5t32 -3.5q50 0 50 40q0 36 -50 36q-12 0 -27 -0.5t-25 -2.5l80 153h61l-61 -107h6q32 0 52.5 -24.5t20.5 -54.5q0 -40 -30 -67t-77 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M123 -220q-63 0 -93 28t-30 72q0 30 18.5 56t48.5 48.5t65 40.5l41 -25q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 600,
    d: "M18 0l282 800l281 -800h-563zM138 76h324l-162 504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 600,
    d: "M66 0v68h87q-39 54 -61.5 121t-22.5 128q0 69 30.5 123.5t82.5 86.5t118 32t118 -32t82 -86.5t30 -123.5q0 -61 -22.5 -128t-61.5 -121h87v-68h-193v78q29 23 51.5 61t35.5 83t13 89q0 155 -140 155q-69 0 -105.5 -39t-36.5 -116q0 -43 13.5 -88.5t36.5 -83.5t51 -61v-78 h-193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 525,
    d: "M155 460v-280q0 -115 98 -115q53 0 85 33t32 82v280h80v-460h-80v62q-24 -34 -59.5 -53t-77.5 -19q-45 0 -78 18v-328h-80v780h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 540,
    d: "M30 460h470v-75h-80v-244q0 -33 7 -47.5t19 -18.5t27 -4v-80q-42 0 -71.5 10t-45.5 38t-16 82v264h-170v-385h-80v385h-60v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0400",
    unicode: "\u0400",
    horizAdvX: 550,
    d: "M100 920l75 40l150 -160l-45 -30zM80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    horizAdvX: 550,
    d: "M325 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM125 825q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM80 700h400v-80h-315v-200h295v-80h-295v-260 h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 435,
    d: "M433 920l-180 -150l-45 30l150 160zM80 700h345v-80h-260v-620h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 565,
    d: "M493 920l-180 -150l-45 30l150 160zM80 700h85v-301l275 301h105l-303 -328l318 -372h-105l-290 340v-340h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 775,
    d: "M255 895l75 40l150 -160l-45 -30zM165 700v-521l530 556v-735h-85v521l-530 -556v735h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 565,
    d: "M127 910h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM565 700l-329 -700h-95l90 207l-231 493h105l179 -409l186 409h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    horizAdvX: 660,
    d: "M560 0l-89 210h-282l-89 -210h-95l325 735l325 -735h-95zM330 542l-107 -252h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 548,
    d: "M80 700h375v-80h-290v-200h105q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -64 -31.5 -111.5t-85 -73t-121.5 -25.5h-190v700zM270 340h-105v-260h105q68 0 110.5 33t42.5 97q0 65 -42.5 97.5t-110.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 558,
    d: "M508 205q0 -69 -31.5 -114.5t-85 -68t-121.5 -22.5h-190v700h180q94 0 151 -43t57 -132q0 -54 -31 -90.5t-85 -52.5q69 -14 112.5 -57.5t43.5 -119.5zM260 625h-95v-208h95q53 0 88 27t35 76q0 50 -35 77.5t-88 27.5zM165 75h105q68 0 110.5 35.5t42.5 99.5 q0 65 -42.5 99t-110.5 34h-105v-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 435,
    d: "M80 700h345v-80h-260v-620h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 795,
    d: "M675 0h-560v-110h-75v190h90l265 655l265 -655h90v-190h-75v110zM395 542l-176 -462h352z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    horizAdvX: 550,
    d: "M80 700h400v-80h-315v-200h295v-80h-295v-260h315v-80h-400v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 895,
    d: "M125 700l285 -312v312h85v-312l275 312h105l-303 -328l318 -372h-105l-290 351v-351h-85v351l-300 -351h-105l318 372l-303 328h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 606,
    d: "M313 -10q-82 0 -138.5 26t-85.5 70.5t-29 98.5h86q5 -49 45 -82t122 -33q83 0 122 34t39 91q0 65 -54 97.5t-137 32.5v75q83 0 127 36t44 85q0 50 -34 81t-102 31q-64 0 -105.5 -30.5t-41.5 -76.5h-81q0 55 28.5 96t80 64.5t118.5 23.5q70 0 120 -26t77 -68t27 -92 q0 -52 -35.5 -94t-97.5 -65q68 -18 110.5 -62t42.5 -118q0 -89 -66 -142t-182 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 775,
    d: "M165 700v-521l530 556v-735h-85v521l-530 -556v735h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 775,
    d: "M257 905h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM165 700v-521l530 556v-735h-85v521l-530 -556v735h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    horizAdvX: 565,
    d: "M80 700h85v-301l275 301h105l-303 -328l318 -372h-105l-290 340v-340h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 658,
    d: "M578 700v-700h-85v620h-310v-380q0 -64 -19.5 -119t-58 -88t-95.5 -33v73q30 0 50.5 24.5t31.5 67t11 95.5v440h475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 810,
    d: "M177 473l-52 -473h-85l85 735l280 -507l280 507l85 -735h-85l-52 473l-228 -408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 715,
    d: "M80 700h85v-280h385v280h85v-700h-85v340h-385v-340h-85v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 790,
    d: "M40 350q0 77 26.5 142.5t74.5 114t113 76t141 27.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-76 0 -141 27.5t-113 76t-74.5 114.5t-26.5 142zM130 350q0 -79 34.5 -141t94.5 -98t136 -36 q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 715,
    d: "M550 620h-385v-620h-85v700h555v-700h-85v620z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 548,
    d: "M80 700h190q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -64 -31.5 -111.5t-85 -73t-121.5 -25.5h-105v-280h-85v700zM270 620h-105v-260h105q68 0 110.5 33t42.5 97q0 65 -42.5 97.5t-110.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 685,
    d: "M130 350q0 -81 36.5 -143t95.5 -97t128 -35q74 0 131 29t94 75v-112q-44 -39 -96 -58t-129 -19q-73 0 -136.5 26.5t-111.5 75t-75 114.5t-27 144t27 144t75 114.5t111.5 75t136.5 26.5q77 0 129 -19t96 -58v-112q-37 47 -94 75.5t-131 28.5q-69 0 -128 -35t-95.5 -96.5 t-36.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    horizAdvX: 465,
    d: "M10 620v80h445v-80h-180v-620h-85v620h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 565,
    d: "M565 700l-329 -700h-95l90 207l-231 493h105l179 -409l186 409h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 783,
    d: "M349 700h85v-80q89 -2 159 -35t110 -92.5t40 -142.5t-40 -142.5t-110 -92.5t-159 -35v-80h-85v80q-89 2 -159 35t-110 92.5t-40 142.5t40 142.5t110 92.5t159 35v80zM658 350q0 90 -62.5 136t-161.5 49v-370q99 3 161.5 49t62.5 136zM125 350q0 -90 62.5 -136t161.5 -49 v370q-99 -3 -161.5 -49t-62.5 -136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 555,
    d: "M430 700h100l-207 -333l222 -367h-100l-165 293l-170 -293h-100l228 367l-203 333h100l146 -259z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 760,
    d: "M165 80h385v620h85v-620h85v-190h-75v110h-565v700h85v-620z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 615,
    d: "M160 700v-182q0 -45 14.5 -82t43.5 -59t72 -22h160v345h85v-700h-85v280h-160q-69 0 -116 31.5t-70.5 85.5t-23.5 121v182h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 985,
    d: "M820 80v620h85v-700h-825v700h85v-620h285v620h85v-620h285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 1030,
    d: "M820 80v620h85v-620h85v-190h-75v110h-835v700h85v-620h285v620h85v-620h285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 658,
    d: "M190 620h-180v80h265v-280h105q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -64 -31.5 -111.5t-85 -73t-121.5 -25.5h-190v620zM380 340h-105v-260h105q68 0 110.5 33t42.5 97q0 65 -42.5 97.5t-110.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 765,
    d: "M600 700h85v-700h-85v700zM80 700h85v-280h105q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -64 -31.5 -111.5t-85 -73t-121.5 -25.5h-190v700zM270 340h-105v-260h105q68 0 110.5 33t42.5 97q0 65 -42.5 97.5t-110.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 548,
    d: "M80 700h85v-280h105q68 0 121.5 -25.5t85 -72.5t31.5 -112q0 -64 -31.5 -111.5t-85 -73t-121.5 -25.5h-190v700zM270 340h-105v-260h105q68 0 110.5 33t42.5 97q0 65 -42.5 97.5t-110.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 685,
    d: "M132 310v80h420q-9 71 -46 123.5t-92.5 82t-118.5 29.5q-74 0 -131 -28.5t-94 -75.5v112q44 39 96.5 58t128.5 19q73 0 136.5 -26.5t111.5 -75t75 -114.5t27 -144t-27 -144t-75 -114.5t-111.5 -75t-136.5 -26.5q-76 0 -128.5 19t-96.5 58v112q37 -46 94 -75t131 -29 q63 0 118.5 29.5t92.5 82t46 123.5h-420z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 1030,
    d: "M80 700h85v-280h121q15 84 63.5 149.5t122 103t163.5 37.5q77 0 141.5 -27.5t112.5 -76t74.5 -114t26.5 -142.5q0 -76 -26.5 -142t-74.5 -114.5t-112.5 -76t-141.5 -27.5q-75 0 -139 26.5t-112 74t-75 111t-29 138.5h-115v-340h-85v700zM370 350q0 -79 34.5 -141 t94.5 -98t136 -36q77 0 136.5 36t94 98t34.5 141t-34.5 141t-94 98t-136.5 36q-76 0 -136 -36t-94.5 -98t-34.5 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 560,
    d: "M480 700v-700h-85v280h-85l-195 -280h-105l209 288q-74 18 -120.5 70.5t-46.5 131.5q0 65 31.5 112t85.5 72.5t121 25.5h190zM290 355h105v270h-105q-67 0 -110 -35t-43 -100q0 -64 43 -99.5t110 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 485,
    d: "M111 352l-39 61q26 19 70 38t106 19q79 0 128 -36.5t49 -103.5v-330h-80v66q-21 -37 -63 -56.5t-94 -19.5q-43 0 -79 16t-57.5 47.5t-21.5 78.5q0 73 52.5 113.5t143.5 40.5q40 0 70 -10t49 -23v77q0 35 -29.5 52.5t-67.5 17.5q-49 0 -84.5 -18t-52.5 -30zM111 135 q0 -37 28.5 -55.5t68.5 -18.5q60 0 98.5 27.5t38.5 91.5v18q-51 27 -115 27q-61 0 -90 -24t-29 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 546,
    d: "M35 290q0 94 18 166t63.5 122t125.5 78q68 23 101.5 55.5t40.5 68.5h79q-7 -67 -63 -115t-138 -74q-58 -19 -91 -55t-48 -81.5t-17 -92.5q24 52 67.5 80t99.5 28q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 33.5t-85.5 100.5 t-31.5 166zM115 230q0 -48 21 -85t56.5 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21q-35 0 -71.5 -19t-61.5 -56t-25 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 453,
    d: "M75 460h170q43 0 78.5 -12.5t57.5 -40t22 -72.5q0 -39 -21 -64t-55 -38q43 -9 69.5 -34t26.5 -74q0 -52 -34.5 -88.5t-113.5 -36.5h-200v460zM245 390h-90v-123h90q36 0 57 18t21 45t-21 43.5t-57 16.5zM255 198h-100v-128h100q45 0 66.5 19t21.5 46t-21.5 45t-66.5 18z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 330,
    d: "M80 460h245v-75h-165v-385h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 655,
    d: "M530 0h-405v-90h-85v165h82l203 420l203 -420h82v-165h-80v90zM325 322l-114 -247h228z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    horizAdvX: 515,
    d: "M472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23t58.5 60zM263 400q-56 0 -97 -32.5 t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 675,
    d: "M120 460l180 -171v171h75v-171l180 171h100l-210 -200l230 -260h-100l-200 245v-245h-75v245l-200 -245h-100l230 260l-210 200h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 471,
    d: "M246 -10q-81 0 -129.5 44t-56.5 111h81q7 -33 30 -59t75 -26q47 0 74 20t27 54q0 35 -28 55.5t-81 20.5v70q46 0 66 17.5t20 42.5q0 27 -20 42.5t-56 15.5q-46 0 -66.5 -24.5t-20.5 -47.5h-81q0 39 22 72t60 52.5t86 19.5q45 0 81 -17t56.5 -45t20.5 -62q0 -67 -72 -98 q43 -13 67.5 -41t24.5 -72q0 -45 -24.5 -77.5t-65.5 -50t-90 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 545,
    d: "M160 460v-298l305 333v-495h-80v298l-305 -333v495h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 545,
    d: "M117 695h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM160 460v-298l305 333v-495h-80v298l-305 -333v495h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 440,
    d: "M70 460h80v-161l170 161h100l-200 -190l220 -270h-100l-190 233v-233h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 558,
    d: "M478 460v-460h-80v385h-235v-225q0 -82 -37.5 -121t-115.5 -39v73q30 0 51.5 19t21.5 68v300h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 607,
    d: "M5 0l120 495l177 -365l180 365l120 -495h-90l-55 268l-155 -299l-152 298l-55 -267h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 565,
    d: "M75 460h80v-180h255v180h80v-460h-80v205h-255v-205h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 546,
    d: "M35 230q0 70 31.5 124t85.5 85t121 31q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-67 0 -121 31t-85.5 85.5t-31.5 123.5zM116 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5t-56 58.5t-80.5 21 t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 525,
    d: "M450 460v-460h-80v385h-215v-385h-80v460h375z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    d: "M150 -220h-80v680h80v-79q25 43 65.5 66t91.5 23q63 0 114.5 -29t82.5 -82.5t31 -128.5q0 -74 -31 -128t-82.5 -83t-114.5 -29q-51 0 -91.5 23t-65.5 66v-299zM454 230q0 53 -21.5 90t-57 56t-78.5 19q-35 0 -69 -19t-56 -56t-22 -90t22 -90t56 -56t69 -19q43 0 78.5 19 t57 56t21.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 478,
    d: "M111 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5q56 0 100 25t60 59v-100q-24 -28 -68.5 -43.5t-91.5 -15.5q-67 0 -121 31t-85.5 85.5t-31.5 123.5q0 70 31.5 124t85.5 85t121 31q47 0 91.5 -15.5t68.5 -43.5v-100q-16 34 -60 59t-100 25q-45 0 -80.5 -21t-56 -58.5 t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 280,
    d: "M5 460h270v-75h-95v-385h-80v385h-95v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 440,
    d: "M440 460l-300 -680h-90l126 285l-176 395h95l129 -317l126 317h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 586,
    d: "M35 230q0 63 27 114t76 83.5t115 40.5v92h80v-92q66 -8 115 -40.5t76 -83.5t27 -114t-27 -114t-76 -83.5t-115 -40.5v-92h-80v92q-66 8 -115 40.5t-76 83.5t-27 114zM470 230q0 63 -36 107t-101 55v-324q65 11 101 55t36 107zM116 230q0 -63 36 -107t101 -55v324 q-65 -11 -101 -55t-36 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 420,
    d: "M320 460h90l-157 -223l167 -237h-90l-120 174l-120 -174h-90l167 237l-157 223h90l110 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 565,
    d: "M450 75h80v-165h-70v90h-385v460h80v-385h215v385h80v-385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 485,
    d: "M130 460v-132q0 -60 21.5 -86.5t78.5 -26.5h100v245h80v-460h-80v140h-100q-69 0 -108.5 19t-55.5 60.5t-16 108.5v132h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 780,
    d: "M430 75h195v385h80v-460h-630v460h80v-385h195v385h80v-385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 820,
    d: "M430 75h195v385h80v-385h80v-165h-70v90h-640v460h80v-385h195v385h80v-385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 578,
    d: "M170 385h-165v75h245v-174h110q71 0 119.5 -34.5t48.5 -108.5t-48.5 -108.5t-119.5 -34.5h-190v385zM360 216h-110v-146h110q44 0 66 19.5t22 53.5q0 35 -22 54t-66 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 645,
    d: "M490 460h80v-460h-80v460zM75 460h80v-174h110q71 0 119.5 -34.5t48.5 -108.5t-48.5 -108.5t-119.5 -34.5h-190v460zM265 216h-110v-146h110q44 0 66 19.5t22 53.5q0 35 -22 54t-66 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 483,
    d: "M75 460h80v-174h110q71 0 119.5 -34.5t48.5 -108.5t-48.5 -108.5t-119.5 -34.5h-190v460zM265 216h-110v-146h110q44 0 66 19.5t22 53.5q0 35 -22 54t-66 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 478,
    d: "M137 267h226q-11 57 -53 92.5t-100 35.5q-55 0 -99.5 -25t-60.5 -59v100q24 28 68.5 43.5t91.5 15.5q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-47 0 -91.5 15.5t-68.5 43.5v100q16 -34 60.5 -59t99.5 -25q58 0 100 35.5t53 92.5h-226 v74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 746,
    d: "M75 460h80v-180h85q10 56 43 99t82 67t108 24q68 0 121.5 -31t85 -85t31.5 -124q0 -69 -31.5 -123.5t-85 -85.5t-121.5 -31q-63 0 -114.5 27.5t-84 76t-38.5 111.5h-81v-205h-80v460zM316 230q0 -48 20.5 -85t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85t-20.5 85.5 t-56 58.5t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 483,
    d: "M141 0h-88l134 189q-50 10 -81 42t-31 91q0 50 22 80t60.5 44t85.5 14h190v-460h-80v184h-82zM243 254h110v136h-110q-88 0 -88 -68t88 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0450",
    unicode: "\u0450",
    horizAdvX: 515,
    d: "M113 680l75 40l150 -160l-45 -30zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23 t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    horizAdvX: 515,
    d: "M308 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM108 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM472 107q-23 -35 -51 -61.5t-68 -41t-100 -14.5 q-62 0 -111.5 31t-78 85.5t-28.5 123.5q0 13 1 25t3 24q10 57 40 100t77.5 67t106.5 24q65 0 114 -29t76 -81.5t27 -125.5v-12t-1 -12h-362q5 -70 44 -107.5t102 -37.5q50 0 85.5 23t58.5 60zM263 400q-56 0 -97 -32.5t-47 -89.5h274q-6 54 -38 88t-92 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 330,
    d: "M383 680l-180 -150l-45 30l150 160zM80 460h245v-75h-165v-385h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 440,
    d: "M425 680l-180 -150l-45 30l150 160zM70 460h80v-161l170 161h100l-200 -190l220 -270h-100l-190 233v-233h-80v460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 545,
    d: "M115 705l75 40l150 -160l-45 -30zM160 460v-298l305 333v-495h-80v298l-305 -333v495h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 440,
    d: "M62 670h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM440 460l-300 -680h-90l126 285l-176 395h95l129 -317l126 317h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 990,
    d: "M495 795l-180 150l75 40l150 -160zM703 185l182 515h95l-275 -735l-210 544l-210 -544l-275 735h95l186 -515l204 550z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 680,
    d: "M335 555l-180 150l75 40l150 -160zM5 460h90l115 -299l125 334l134 -336l116 301h90l-200 -495l-139 335l-131 -335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 990,
    d: "M495 795l-45 30l150 160l75 -40zM703 185l182 515h95l-275 -735l-210 544l-210 -544l-275 735h95l186 -515l204 550z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 680,
    d: "M335 555l-45 30l150 160l75 -40zM5 460h90l115 -299l125 334l134 -336l116 301h90l-200 -495l-139 335l-131 -335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 990,
    d: "M540 850q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM340 850q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM703 185l182 515h95l-275 -735l-210 544 l-210 -544l-275 735h95l186 -515l204 550z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 680,
    d: "M380 610q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM180 610q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM5 460h90l115 -299l125 334l134 -336l116 301 h90l-200 -495l-139 335l-131 -335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E86",
    unicode: "\u1E86",
    horizAdvX: 990,
    d: "M440 850q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM703 185l182 515h95l-275 -735l-210 544l-210 -544l-275 735h95l186 -515l204 550z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E87",
    unicode: "\u1E87",
    horizAdvX: 680,
    d: "M280 610q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM5 460h90l115 -299l125 334l134 -336l116 301h90l-200 -495l-139 335l-131 -335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E88",
    unicode: "\u1E88",
    horizAdvX: 990,
    d: "M440 -150q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM703 185l182 515h95l-275 -735l-210 544l-210 -544l-275 735h95l186 -515l204 550z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E89",
    unicode: "\u1E89",
    horizAdvX: 680,
    d: "M285 -150q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM5 460h90l115 -299l125 334l134 -336l116 301h90l-200 -495l-139 335l-131 -335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 716,
    d: "M422 -12q-64 0 -109.5 18.5t-82.5 47.5l40 72q35 -23 70.5 -37.5t87.5 -14.5q41 0 77.5 10t59.5 32.5t23 59.5q0 35 -19 53.5t-47.5 29l-57 21t-47.5 28.5t-19 52q0 29 13.5 47.5t33.5 31.5t40 25.5t33.5 28.5t13.5 41q0 21 -13 42t-43.5 34.5t-82.5 13.5 q-62 0 -114.5 -24.5t-83.5 -78t-31 -139.5l2 -384h-86v391q0 84 27 144.5t73 99.5t104.5 57.5t121.5 18.5q99 0 157.5 -42.5t58.5 -114.5q0 -38 -12.5 -63.5t-31.5 -43t-38 -30.5t-31.5 -24t-12.5 -25q0 -17 18.5 -26.5t45.5 -19t54 -24.5t45.5 -42t18.5 -72 q0 -57 -32.5 -100.5t-90.5 -68.5t-133 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 561,
    d: "M281 770l-180 150l75 40l150 -160zM461 700h95l-233 -398v-302h-85v301l-233 399h95l180 -324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 440,
    d: "M220 530l-180 150l75 40l150 -160zM440 460l-300 -680h-90l126 285l-176 395h95l129 -317l126 317h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 210,
    d: "M5 200v75h200v-75h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "figuredash",
    unicode: "\u2012",
    horizAdvX: 590,
    d: "M70 200v75h450v-75h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 740,
    d: "M70 200v75h600v-75h-600z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 890,
    d: "M70 200v75h750v-75h-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 275,
    d: "M165 470h-95l100 230h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 275,
    d: "M110 700h95l-100 -230h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 275,
    d: "M120 80h95l-100 -230h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 475,
    d: "M165 470h-95l100 230h55zM365 470h-95l100 230h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 475,
    d: "M110 700h95l-100 -230h-55zM310 700h95l-100 -230h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 475,
    d: "M110 80h95l-100 -230h-55zM310 80h95l-100 -230h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    d: "M90 540h155v160h80v-160h155v-75h-155v-615h-80v615h-155v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    d: "M90 120h155v345h-155v75h155v160h80v-160h155v-75h-155v-345h155v-75h-155v-195h-80v195h-155v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 300,
    d: "M95 415q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 900,
    d: "M95 40q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM395 40q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM695 40q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39 q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1131,
    d: "M35 550q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM563 700h75l-450 -700h-75zM106 550q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5 t-23 -66.5zM780 150q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM400 150q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5 t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM851 150q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5t-23 -66.5zM471 150q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5t-23 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2031",
    unicode: "\u2031",
    horizAdvX: 1511,
    d: "M35 550q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM563 700h75l-450 -700h-75zM106 550q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5 t-23 -66.5zM1160 150q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM780 150q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5 t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM400 150q0 45 19.5 81t55.5 57.5t83 21.5q48 0 83.5 -21.5t55 -57.5t19.5 -81q0 -44 -19.5 -80.5t-55 -58t-83.5 -21.5q-47 0 -83 21.5t-55.5 58t-19.5 80.5zM1231 150q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5 t-23 66.5t-64 28.5t-64 -28.5t-23 -66.5zM851 150q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5t-23 -66.5zM471 150q0 -38 23 -66.5t64 -28.5t64 28.5t23 66.5t-23 66.5t-64 28.5t-64 -28.5t-23 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 350,
    d: "M130 259l150 -194l-50 -45l-190 235l190 235l50 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 350,
    d: "M220 251l-150 194l50 45l190 -235l-190 -235l-50 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni203D",
    unicode: "\u203D",
    horizAdvX: 557,
    d: "M200 510h100l-9 -156q59 17 92 59t33 87q0 65 -39.5 100t-107.5 35q-50 0 -85.5 -22.5t-58.5 -60.5l-65 41q23 35 51 61.5t68.5 41t99.5 14.5q63 0 112 -27.5t77.5 -75t28.5 -107.5q0 -57 -29.5 -103.5t-77.5 -74.5t-103 -32l-7 -120h-60zM195 40q0 23 16.5 39t38.5 16 q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 705,
    d: "M580 700h65l-520 -700h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2070",
    unicode: "\u2070",
    horizAdvX: 372,
    d: "M30 490q0 63 20 111.5t55 76.5t81 28t81 -28t55 -76.5t20 -111.5q0 -62 -20 -111t-55 -77t-81 -28t-81 28t-55 77t-20 111zM81 490q0 -73 28 -120.5t77 -47.5t77 47.5t28 120.5q0 74 -28 121t-77 47t-77 -47t-28 -121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2074",
    unicode: "\u2074",
    horizAdvX: 386,
    d: "M233 280v84h-203l233 336h21v-291h66v-45h-66v-84h-51zM233 587l-119 -178h119v178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2075",
    unicode: "\u2075",
    horizAdvX: 356,
    d: "M326 416q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70t-67.5 26q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159l-27 -111q29 16 62 16q54 0 89.5 -40t35.5 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2076",
    unicode: "\u2076",
    horizAdvX: 346,
    d: "M204 698h65l-119 -156q10 6 22 8t26 2q34 0 62 -18t45 -48.5t17 -69.5q0 -64 -41 -104t-102 -40t-102 40t-41 104q0 26 7.5 48.5t19.5 38.5zM85 416q0 -43 27 -70.5t67 -27.5q41 0 67.5 27.5t26.5 70.5q0 44 -26.5 71.5t-67.5 27.5q-40 0 -67 -27.5t-27 -71.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2077",
    unicode: "\u2077",
    horizAdvX: 354,
    d: "M30 652v48h294l-201 -420h-53l178 372h-218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2078",
    unicode: "\u2078",
    horizAdvX: 322,
    d: "M30 394q0 41 21.5 69t53.5 41q-28 12 -44 36.5t-16 58.5q0 44 33.5 75.5t82.5 31.5q50 0 83 -31.5t33 -75.5q0 -34 -16 -58.5t-44 -36.5q32 -13 53.5 -41t21.5 -69q0 -32 -17 -59.5t-46.5 -44t-67.5 -16.5q-37 0 -67 16.5t-47 44t-17 59.5zM94 593q0 -30 20 -48.5 t47 -18.5t47 18.5t20 48.5t-19 49t-48 19t-48 -19t-19 -49zM79 400q0 -39 25.5 -60t56.5 -21q32 0 57 21t25 60q0 35 -25 58t-57 23q-31 0 -56.5 -23t-25.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2079",
    unicode: "\u2079",
    horizAdvX: 346,
    d: "M160 282h-65l119 156q-10 -6 -22 -8t-26 -2q-34 0 -62 18t-45 49t-17 69q0 65 41 104.5t102 39.5t102 -39.5t41 -104.5q0 -25 -7.5 -47.5t-19.5 -39.5zM279 564q0 44 -26.5 71t-67.5 27q-40 0 -67 -27t-27 -71q0 -43 27 -71t67 -28q41 0 67.5 28t26.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    horizAdvX: 372,
    d: "M30 210q0 63 20 111.5t55 76.5t81 28t81 -28t55 -76.5t20 -111.5q0 -62 -20 -111t-55 -77t-81 -28t-81 28t-55 77t-20 111zM81 210q0 -73 28 -120.5t77 -47.5t77 47.5t28 120.5q0 74 -28 121t-77 47t-77 -47t-28 -121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    horizAdvX: 314,
    d: "M90 338v53l144 36v-426h-51v365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    horizAdvX: 346,
    d: "M25 2l198 212q21 22 32.5 44.5t11.5 47.5q0 28 -19 51.5t-57 23.5q-40 0 -65.5 -27.5t-25.5 -75.5h-51q0 67 38.5 109t103.5 42q46 0 74 -20t41 -49.5t13 -57.5q0 -32 -15.5 -61t-40.5 -55l-133 -136h191v-48h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    horizAdvX: 312,
    d: "M159 -6q-61 0 -97.5 34t-36.5 83h52q0 -30 23 -49.5t59 -19.5t57.5 20.5t21.5 54.5q0 39 -28 58.5t-69 19.5v45q41 0 63 21.5t22 51.5t-16 48.5t-48 18.5q-29 0 -49.5 -18t-20.5 -46h-49q0 49 33.5 79.5t85.5 30.5q54 0 85 -34t31 -78q0 -31 -19 -56.5t-52 -38.5 q36 -11 59.5 -37.5t23.5 -70.5q0 -53 -37.5 -85t-93.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    horizAdvX: 386,
    d: "M233 0v84h-203l233 336h21v-291h66v-45h-66v-84h-51zM233 307l-119 -178h119v178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    horizAdvX: 356,
    d: "M326 136q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70t-67.5 26q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159l-27 -111q29 16 62 16q54 0 89.5 -40t35.5 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    horizAdvX: 346,
    d: "M203 418h65l-119 -156q10 6 22 8t26 2q34 0 62 -18t45 -48.5t17 -69.5q0 -64 -41 -104t-102 -40t-102 40t-41 104q0 26 7.5 48.5t19.5 38.5zM84 136q0 -43 27 -70.5t67 -27.5q41 0 67.5 27.5t26.5 70.5q0 44 -26.5 71.5t-67.5 27.5q-40 0 -67 -27.5t-27 -71.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    horizAdvX: 354,
    d: "M30 372v48h294l-201 -420h-53l178 372h-218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    horizAdvX: 322,
    d: "M30 114q0 41 21.5 69t53.5 41q-28 12 -44 36.5t-16 58.5q0 44 33.5 75.5t82.5 31.5q50 0 83 -31.5t33 -75.5q0 -34 -16 -58.5t-44 -36.5q32 -13 53.5 -41t21.5 -69q0 -32 -17 -59.5t-46.5 -44t-67.5 -16.5q-37 0 -67 16.5t-47 43.5t-17 60zM94 313q0 -30 20 -48.5 t47 -18.5t47 18.5t20 48.5t-19 49t-48 19t-48 -19t-19 -49zM79 120q0 -39 25.5 -60t56.5 -21q32 0 57 21t25 60q0 35 -25 58t-57 23q-31 0 -56.5 -23t-25.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    horizAdvX: 346,
    d: "M143 2h-65l119 156q-10 -6 -22 -8t-26 -2q-34 0 -62 18t-45 48.5t-17 69.5q0 65 41 104.5t102 39.5t102 -39.5t41 -104.5q0 -25 -7.5 -47.5t-19.5 -39.5zM262 284q0 44 -26.5 71t-67.5 27q-40 0 -67 -27t-27 -71q0 -43 27 -71t67 -28q41 0 67.5 28t26.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 580,
    d: "M15 287v48h55v15q0 29 3 57h-58v48h66q18 76 59 133.5t99.5 89.5t130.5 32q41 0 78.5 -10.5t71.5 -30.5v-101q-64 62 -150 62q-74 0 -127 -48t-75 -127h348v-48h-357q-4 -28 -4 -57v-15h335v-48h-330q9 -65 38 -113.5t73 -76t99 -27.5q86 0 150 62v-101 q-34 -19 -71.5 -30t-78.5 -11q-78 0 -141 37.5t-103.5 104.5t-51.5 155h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 665,
    d: "M590 717l42 -367h-42l-26 235l-114 -203l-114 203l-26 -235h-42l42 367l140 -253zM32 660v40h223v-40h-90v-310h-43v310h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2150",
    unicode: "\u2150",
    horizAdvX: 842,
    d: "M568 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM518 372v48h294l-201 -420h-53l178 372h-218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2151",
    unicode: "\u2151",
    horizAdvX: 784,
    d: "M568 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM598 2h-65l119 156q-10 -6 -22 -8t-26 -2q-34 0 -62 18t-45 48.5t-17 69.5q0 65 41 104.5t102 39.5t102 -39.5t41 -104.5q0 -25 -7.5 -47.5t-19.5 -39.5zM717 284q0 44 -26.5 71t-67.5 27q-40 0 -67 -27 t-27 -71q0 -43 27 -71t67 -28q41 0 67.5 28t26.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2152",
    unicode: "\u2152",
    horizAdvX: 1080,
    d: "M568 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM488 338v53l144 36v-426h-51v365zM738 210q0 63 20 111.5t55 76.5t81 28t81 -28t55 -76.5t20 -111.5q0 -62 -20 -111t-55 -77t-81 -28t-81 28t-55 77t-20 111zM789 210q0 -73 28 -120.5t77 -47.5t77 47.5 t28 120.5q0 74 -28 121t-77 47t-77 -47t-28 -121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 755,
    d: "M568 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM597 -6q-61 0 -97.5 34t-36.5 83h52q0 -30 23 -49.5t59 -19.5t57.5 20.5t21.5 54.5q0 39 -28 58.5t-69 19.5v45q41 0 63 21.5t22 51.5t-16 48.5t-48 18.5q-29 0 -49.5 -18t-20.5 -46h-49q0 49 33.5 79.5 t85.5 30.5q54 0 85 -34t31 -78q0 -31 -19 -56.5t-52 -38.5q36 -11 59.5 -37.5t23.5 -70.5q0 -53 -37.5 -85t-93.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 882,
    d: "M30 282l198 212q21 22 32.5 44.5t11.5 47.5q0 28 -19 51.5t-57 23.5q-40 0 -65.5 -27.5t-25.5 -75.5h-51q0 67 38.5 109t103.5 42q46 0 74 -20t41 -49.5t13 -57.5q0 -32 -15.5 -61t-40.5 -55l-133 -136h191v-48h-296zM695 700h65l-520 -700h-65zM724 -6q-61 0 -97.5 34 t-36.5 83h52q0 -30 23 -49.5t59 -19.5t57.5 20.5t21.5 54.5q0 39 -28 58.5t-69 19.5v45q41 0 63 21.5t22 51.5t-16 48.5t-48 18.5q-29 0 -49.5 -18t-20.5 -46h-49q0 49 33.5 79.5t85.5 30.5q54 0 85 -34t31 -78q0 -31 -19 -56.5t-52 -38.5q36 -11 59.5 -37.5t23.5 -70.5 q0 -53 -37.5 -85t-93.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2155",
    unicode: "\u2155",
    horizAdvX: 744,
    d: "M568 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM554 373l-27 -111q29 16 62 16q54 0 89.5 -40t35.5 -102q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70t-67.5 26 q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2156",
    unicode: "\u2156",
    horizAdvX: 871,
    d: "M30 282l198 212q21 22 32.5 44.5t11.5 47.5q0 28 -19 51.5t-57 23.5q-40 0 -65.5 -27.5t-25.5 -75.5h-51q0 67 38.5 109t103.5 42q46 0 74 -20t41 -49.5t13 -57.5q0 -32 -15.5 -61t-40.5 -55l-133 -136h191v-48h-296zM695 700h65l-520 -700h-65zM681 373l-27 -111 q29 16 62 16q54 0 89.5 -40t35.5 -102q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70t-67.5 26q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2157",
    unicode: "\u2157",
    horizAdvX: 831,
    d: "M164 274q-61 0 -97.5 34t-36.5 83h52q0 -30 23 -49.5t59 -19.5t57.5 20.5t21.5 54.5q0 39 -28 58.5t-69 19.5v45q41 0 63 21.5t22 51.5t-16 48.5t-48 18.5q-29 0 -49.5 -18t-20.5 -46h-49q0 49 33.5 79.5t85.5 30.5q54 0 85 -34t31 -78q0 -31 -19 -56.5t-52 -38.5 q36 -11 59.5 -37.5t23.5 -70.5q0 -53 -37.5 -85t-93.5 -32zM655 700h65l-520 -700h-65zM641 373l-27 -111q29 16 62 16q54 0 89.5 -40t35.5 -102q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70 t-67.5 26q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2158",
    unicode: "\u2158",
    horizAdvX: 866,
    d: "M690 700h65l-520 -700h-65zM233 280v84h-203l233 336h21v-291h66v-45h-66v-84h-51zM233 587l-119 -178h119v178zM676 373l-27 -111q29 16 62 16q54 0 89.5 -40t35.5 -102q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5 q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70t-67.5 26q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2159",
    unicode: "\u2159",
    horizAdvX: 734,
    d: "M568 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM592 418h65l-119 -156q10 6 22 8t26 2q34 0 62 -18t45 -48.5t17 -69.5q0 -64 -41 -104t-102 -40t-102 40t-41 104q0 26 7.5 48.5t19.5 38.5zM473 136q0 -43 27 -70.5t67 -27.5q41 0 67.5 27.5t26.5 70.5 q0 44 -26.5 71.5t-67.5 27.5q-40 0 -67 -27.5t-27 -71.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni215A",
    unicode: "\u215A",
    horizAdvX: 856,
    d: "M690 700h65l-520 -700h-65zM326 416q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70t-67.5 26q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159l-27 -111q29 16 62 16q54 0 89.5 -40 t35.5 -102zM714 418h65l-119 -156q10 6 22 8t26 2q34 0 62 -18t45 -48.5t17 -69.5q0 -64 -41 -104t-102 -40t-102 40t-41 104q0 26 7.5 48.5t19.5 38.5zM595 136q0 -43 27 -70.5t67 -27.5q41 0 67.5 27.5t26.5 70.5q0 44 -26.5 71.5t-67.5 27.5q-40 0 -67 -27.5t-27 -71.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 760,
    d: "M568 700h65l-520 -700h-65zM30 611v53l144 36v-426h-51v365zM468 114q0 41 21.5 69t53.5 41q-28 12 -44 36.5t-16 58.5q0 44 33.5 75.5t82.5 31.5q50 0 83 -31.5t33 -75.5q0 -34 -16 -58.5t-44 -36.5q32 -13 53.5 -41t21.5 -69q0 -32 -17 -59.5t-46.5 -44t-67.5 -16.5 q-37 0 -67 16.5t-47 43.5t-17 60zM532 313q0 -30 20 -48.5t47 -18.5t47 18.5t20 48.5t-19 49t-48 19t-48 -19t-19 -49zM517 120q0 -39 25.5 -60t56.5 -21q32 0 57 21t25 60q0 35 -25 58t-57 23q-31 0 -56.5 -23t-25.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 847,
    d: "M164 274q-61 0 -97.5 34t-36.5 83h52q0 -30 23 -49.5t59 -19.5t57.5 20.5t21.5 54.5q0 39 -28 58.5t-69 19.5v45q41 0 63 21.5t22 51.5t-16 48.5t-48 18.5q-29 0 -49.5 -18t-20.5 -46h-49q0 49 33.5 79.5t85.5 30.5q54 0 85 -34t31 -78q0 -31 -19 -56.5t-52 -38.5 q36 -11 59.5 -37.5t23.5 -70.5q0 -53 -37.5 -85t-93.5 -32zM655 700h65l-520 -700h-65zM555 114q0 41 21.5 69t53.5 41q-28 12 -44 36.5t-16 58.5q0 44 33.5 75.5t82.5 31.5q50 0 83 -31.5t33 -75.5q0 -34 -16 -58.5t-44 -36.5q32 -13 53.5 -41t21.5 -69q0 -32 -17 -59.5 t-46.5 -44t-67.5 -16.5q-37 0 -67 16.5t-47 43.5t-17 60zM619 313q0 -30 20 -48.5t47 -18.5t47 18.5t20 48.5t-19 49t-48 19t-48 -19t-19 -49zM604 120q0 -39 25.5 -60t56.5 -21q32 0 57 21t25 60q0 35 -25 58t-57 23q-31 0 -56.5 -23t-25.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 882,
    d: "M690 700h65l-520 -700h-65zM326 416q0 -71 -43 -107.5t-104 -36.5q-58 0 -93 26t-56 62l43 30q14 -27 43 -48.5t63 -21.5q45 0 69.5 26.5t24.5 69.5q0 44 -26.5 70t-67.5 26q-30 0 -52.5 -7.5t-54.5 -30.5l55 224h198v-45h-159l-27 -111q29 16 62 16q54 0 89.5 -40 t35.5 -102zM590 114q0 41 21.5 69t53.5 41q-28 12 -44 36.5t-16 58.5q0 44 33.5 75.5t82.5 31.5q50 0 83 -31.5t33 -75.5q0 -34 -16 -58.5t-44 -36.5q32 -13 53.5 -41t21.5 -69q0 -32 -17 -59.5t-46.5 -44t-67.5 -16.5q-37 0 -67 16.5t-47 43.5t-17 60zM654 313 q0 -30 20 -48.5t47 -18.5t47 18.5t20 48.5t-19 49t-48 19t-48 -19t-19 -49zM639 120q0 -39 25.5 -60t56.5 -21q32 0 57 21t25 60q0 35 -25 58t-57 23q-31 0 -56.5 -23t-25.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 772,
    d: "M580 700h65l-520 -700h-65zM30 652v48h294l-201 -420h-53l178 372h-218zM480 114q0 41 21.5 69t53.5 41q-28 12 -44 36.5t-16 58.5q0 44 33.5 75.5t82.5 31.5q50 0 83 -31.5t33 -75.5q0 -34 -16 -58.5t-44 -36.5q32 -13 53.5 -41t21.5 -69q0 -32 -17 -59.5t-46.5 -44 t-67.5 -16.5q-37 0 -67 16.5t-47 43.5t-17 60zM544 313q0 -30 20 -48.5t47 -18.5t47 18.5t20 48.5t-19 49t-48 19t-48 -19t-19 -49zM529 120q0 -39 25.5 -60t56.5 -21q32 0 57 21t25 60q0 35 -25 58t-57 23q-31 0 -56.5 -23t-25.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 546,
    d: "M273 -10q-69 0 -123 31t-84.5 85t-30.5 124q0 66 27 117t73.5 80.5t106.5 29.5t125 -32q-33 59 -84.5 118.5t-124.5 125.5l48 56q107 -107 174.5 -194t99 -160.5t31.5 -140.5q0 -70 -30.5 -124t-84 -85t-123.5 -31zM273 67q46 0 81.5 21t55.5 58t20 84q0 48 -20.5 85 t-56 58.5t-80.5 21.5t-80.5 -21.5t-56 -58.5t-20.5 -85q0 -47 20 -84t55.5 -58t81.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emptyset",
    unicode: "\u2205",
    horizAdvX: 600,
    d: "M124 30l-37 36l44 44q-21 28 -33 61.5t-12 70.5q0 59 29 107.5t77.5 77.5t107.5 29q37 0 71 -12t61 -34l44 44l38 -36l-45 -45q21 -27 33 -60.5t12 -70.5q0 -59 -29 -107.5t-77.5 -77.5t-107.5 -29q-37 0 -71 12t-61 34zM148 242q0 -48 28 -88l212 212q-40 28 -88 28 q-42 0 -76.5 -20.5t-55 -55t-20.5 -76.5zM300 90q43 0 77 21.5t54.5 56t20.5 74.5q0 48 -27 87l-213 -211q40 -28 88 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 600,
    d: "M160 0v630h-85v70h450v-70h-85v-630h-80v630h-120v-630h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 600,
    d: "M100 0l170 352l-170 348h400v-72h-284l134 -276l-134 -280h284v-72h-400z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 590,
    d: "M70 200v75h450v-75h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 515,
    d: "M420 700h80l-405 -850h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 300,
    d: "M95 415q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 600,
    d: "M243 -200l-120 360l-64 -16l-14 57l133 33l49 -182l117 648h158v-72h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 750,
    d: "M191 48q-45 0 -83.5 25.5t-62 67t-23.5 89.5q0 49 23.5 89.5t62 65.5t83.5 25q92 0 185 -120q93 120 184 120q45 0 83.5 -25t61.5 -65.5t23 -89.5q0 -48 -23 -89.5t-61.5 -67t-83.5 -25.5q-91 0 -184 120q-94 -120 -185 -120zM202 126q33 0 66.5 27t64.5 77 q-30 50 -64 76.5t-67 26.5q-25 0 -47 -14.5t-35.5 -37.5t-13.5 -51q0 -27 13.5 -50.5t35.5 -38.5t47 -15zM549 126q25 0 46.5 15t35 38.5t13.5 50.5q0 28 -13.5 51t-35 37.5t-46.5 14.5q-33 0 -67 -26.5t-64 -76.5q30 -49 64 -76.5t67 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 600,
    d: "M204 -200q-22 1 -42.5 10.5t-46.5 31.5l43 62q16 -15 25.5 -20.5t18.5 -5.5q46 0 52 90l37 658q5 77 40 121t91 42q23 -1 43.5 -10t45.5 -32l-43 -62q-16 15 -25.5 20.5t-18.5 5.5q-22 0 -35.5 -23.5t-16.5 -67.5l-37 -658q-4 -76 -39.5 -119.5t-91.5 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 600,
    d: "M394 372q-52 0 -115 48q-24 18 -43.5 25.5t-42.5 7.5q-33 0 -47 -22t-4 -55l-74 5q-10 35 5.5 68.5t48 55.5t72.5 22q61 0 123 -48q41 -32 73 -32q27 0 38 23t-1 53l79 -5q9 -37 -4.5 -70.5t-42 -54.5t-65.5 -21zM394 122q-52 0 -115 48q-24 18 -43.5 25.5t-42.5 7.5 q-33 0 -47 -22t-4 -55l-74 5q-10 35 5.5 68.5t48 55.5t72.5 22q61 0 123 -48q41 -32 73 -32q27 0 38 23t-1 53l79 -5q9 -37 -4.5 -70.5t-42 -54.5t-65.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 600,
    d: "M65 140v75h171l44 75h-215v75h258l73 127l65 -38l-51 -89h140v-75h-183l-44 -75h227v-75h-270l-61 -106l-65 38l39 68h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 600,
    d: "M550 115l-510 220v45l510 220v-80l-378 -158l378 -167v-80zM40 0v80h510v-80h-510z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 600,
    d: "M65 115v80l378 158l-378 167v80l510 -220v-45zM65 0v80h510v-80h-510z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 600,
    d: "M306 15l-206 341l206 340l194 -340zM303 172l106 184l-106 184l-112 -184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF10",
    unicode: "\uFF10",
    horizAdvX: 580,
    d: "M30 350q0 105 33 186t91.5 127.5t135.5 46.5t135.5 -46.5t91.5 -127.5t33 -186t-33 -186t-91.5 -127.5t-135.5 -46.5t-135.5 46.5t-91.5 127.5t-33 186zM115 350q0 -81 21.5 -144.5t60.5 -99.5t93 -36t93.5 36t60.5 99.5t21 144.5q0 82 -21 145t-60.5 99t-93.5 36 t-93 -36t-60.5 -99t-21.5 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF11",
    unicode: "\uFF11",
    horizAdvX: 580,
    d: "M115 562v88l240 60v-710h-85v608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF12",
    unicode: "\uFF12",
    horizAdvX: 580,
    d: "M26 0l330 353q35 37 54.5 74t19.5 79q0 31 -14.5 59.5t-42.5 47t-71 18.5q-67 0 -109.5 -45.5t-42.5 -125.5h-84q0 75 29 131.5t82 88t125 31.5q58 0 98.5 -19.5t66 -51t37.5 -69t12 -72.5q0 -54 -25.5 -102t-66.5 -90l-224 -227h320v-80h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF13",
    unicode: "\uFF13",
    horizAdvX: 580,
    d: "M300 -10q-67 0 -117.5 26t-78 70.5t-27.5 98.5h86q0 -49 38.5 -82t98.5 -33t95.5 34t35.5 91q0 65 -46.5 97.5t-114.5 32.5v75q68 0 104.5 36t36.5 85q0 50 -26.5 81t-79.5 31q-49 0 -83 -30.5t-34 -76.5h-81q0 55 25.5 96t70 64.5t101.5 23.5q60 0 103.5 -26t67 -68 t23.5 -92q0 -52 -32 -94t-87 -65q62 -18 100.5 -62t38.5 -118q0 -59 -28.5 -103t-77.5 -68t-112 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF14",
    unicode: "\uFF14",
    horizAdvX: 580,
    d: "M356 0v140h-338l388 560h35v-485h110v-75h-110v-140h-85zM356 511l-198 -296h198v296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF15",
    unicode: "\uFF15",
    horizAdvX: 580,
    d: "M532 230q0 -79 -33 -132.5t-88.5 -80.5t-123.5 -27q-64 0 -111.5 20t-81 53.5t-56.5 73.5l72 49q16 -30 42.5 -56.5t61 -43t73.5 -16.5q75 0 116 44t41 116q0 48 -20.5 84t-56 56t-80.5 20q-33 0 -60.5 -5.5t-55 -19t-63.5 -38.5l92 373h330v-75h-264l-47 -185 q48 26 104 26q60 0 107.5 -30t74.5 -83t27 -123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF16",
    unicode: "\uFF16",
    horizAdvX: 580,
    d: "M332 700h107l-197 -260q17 10 36.5 13.5t42.5 3.5q57 0 104 -30t75 -81t28 -116q0 -72 -31.5 -126t-85 -84t-121.5 -30q-67 0 -121 30t-85.5 84t-31.5 126q0 43 12 80t32 65zM133 230q0 -48 20.5 -84.5t56 -57.5t80.5 -21t80.5 21t56 57.5t20.5 84.5t-20.5 85.5t-56 58.5 t-80.5 21t-80.5 -21t-56 -58.5t-20.5 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF17",
    unicode: "\uFF17",
    horizAdvX: 580,
    d: "M58 620v80h490l-336 -700h-88l296 620h-362z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF18",
    unicode: "\uFF18",
    horizAdvX: 580,
    d: "M72 190q0 69 35.5 115.5t88.5 67.5q-46 20 -72.5 60.5t-26.5 97.5q0 50 25.5 90.5t69 64.5t98.5 24t98.5 -24t69 -64.5t25.5 -90.5q0 -57 -26.5 -97.5t-72.5 -60.5q53 -21 88.5 -67.5t35.5 -115.5q0 -54 -28.5 -99.5t-77.5 -73t-112 -27.5q-62 0 -111.5 27.5t-78 73 t-28.5 99.5zM178 521q0 -49 33.5 -80t78.5 -31t78.5 31t33.5 80q0 50 -31.5 82t-80.5 32t-80.5 -32t-31.5 -82zM153 200q0 -43 19.5 -73t51 -46t66.5 -16t66.5 16t51 46t19.5 73q0 38 -19.5 68.5t-51 48.5t-66.5 18t-66.5 -18t-51 -48.5t-19.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFF19",
    unicode: "\uFF19",
    horizAdvX: 580,
    d: "M248 0h-107l197 260q-17 -10 -36.5 -13.5t-42.5 -3.5q-57 0 -104 30t-75 81.5t-28 115.5q0 72 31.5 126t85.5 84t121 30q68 0 121.5 -30t85 -84t31.5 -126q0 -43 -12 -80t-32 -65zM447 470q0 48 -20.5 84.5t-56 57.5t-80.5 21t-80.5 -21t-56 -57.5t-20.5 -84.5t20.5 -85 t56 -58.5t80.5 -21.5t80.5 21.5t56 58.5t20.5 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    d: "M35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19 t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.alt",
    d: "M113 680l75 40l150 -160l-45 -30zM35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90 t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.alt",
    d: "M393 680l-180 -150l-45 30l150 160zM35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90 t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.alt",
    d: "M283 625l-110 -95l-50 40l160 140l160 -140l-50 -40zM35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19 t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.alt",
    d: "M118 567q8 37 39 59.5t65 22.5q24 0 39.5 -7t27 -16.5t24.5 -16.5t33 -7q26 0 56 48l46 -43q-12 -28 -40 -50.5t-66 -22.5q-27 0 -46 12t-35.5 23.5t-39.5 11.5q-20 0 -31 -9.5t-15 -21.5t-4 -20zM35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5 v88h75v-460h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.alt",
    d: "M328 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM128 585q0 23 16.5 39t38.5 16q23 0 39 -16t16 -39q0 -22 -16 -38.5t-39 -16.5q-22 0 -38.5 16.5t-16.5 38.5zM35 230q0 75 31 128.5t82.5 82.5t114.5 29 q54 0 95.5 -25.5t66.5 -72.5v88h75v-460h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.alt",
    d: "M181 630q0 45 31.5 72.5t70.5 27.5t70.5 -27.5t31.5 -72.5t-31.5 -72.5t-70.5 -27.5t-70.5 27.5t-31.5 72.5zM232 630q0 -25 16 -39t35 -14t35 14t16 39t-16 39t-35 14t-35 -14t-16 -39zM35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460 h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.alt",
    d: "M98 530v75h350v-75h-350zM35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460h-75v88q-25 -47 -66.5 -72.5t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56 t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.alt",
    d: "M105 670h71q0 -13 7 -30.5t26 -31t54 -13.5t54 13.5t26 31t7 30.5h71q0 -34 -17.5 -66.5t-52.5 -53t-88 -20.5q-52 0 -87.5 20.5t-53 53t-17.5 66.5zM35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460h-75v88q-25 -47 -66.5 -72.5 t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.alt",
    d: "M35 230q0 75 31 128.5t82.5 82.5t114.5 29q54 0 95.5 -25.5t66.5 -72.5v88h75v-460q-39 -16 -66 -44t-27 -56q0 -27 13 -38.5t35 -11.5q20 0 30 5t20 15l33 -50q-11 -15 -33.5 -27.5t-54.5 -12.5q-63 0 -93 28t-30 72q0 37 28.5 69t69.5 57v82q-25 -47 -66.5 -72.5 t-95.5 -25.5q-62 0 -114 29t-83 83t-31 128zM116 230q0 -53 21.5 -90t57.5 -56t78 -19q35 0 69 19t56 56t22 90t-22 90t-56 56t-69 19q-42 0 -78 -19t-57.5 -56t-21.5 -90z"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,s,agrave,aacute,acircumflex,atilde,adieresis,aring,egrave,eacute,ecircumflex,edieresis,ntilde,amacron,abreve,aogonek,hcircumflex,nacute,uni0146,ncaron,uni0430,uni0432,uni0434,uni0437,uni043C,uni0446,uni0449",
    g2: "quotedbl,quotesingle,asterisk,grave,ordfeminine,macron,ordmasculine,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,s,agrave,aacute,acircumflex,atilde,adieresis,aring,egrave,eacute,ecircumflex,edieresis,ntilde,amacron,abreve,aogonek,hcircumflex,nacute,uni0146,ncaron,uni0430,uni0432,uni0434,uni0437,uni043C,uni0446,uni0449",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,s,agrave,aacute,acircumflex,atilde,adieresis,aring,egrave,eacute,ecircumflex,edieresis,ntilde,amacron,abreve,aogonek,hcircumflex,nacute,uni0146,ncaron,uni0430,uni0432,uni0434,uni0437,uni043C,uni0446,uni0449",
    g2: "V,W,backslash,Wcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,s,agrave,aacute,acircumflex,atilde,adieresis,aring,egrave,eacute,ecircumflex,edieresis,ntilde,amacron,abreve,aogonek,hcircumflex,nacute,uni0146,ncaron,uni0430,uni0432,uni0434,uni0437,uni043C,uni0446,uni0449",
    g2: "T,Y,Ydieresis,uni0422",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,oe,uni042A,uni042C,uni0435,uni043E,uni0440,uni044E,uni0450,uni0451",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,oe,uni042A,uni042C,uni0435,uni043E,uni0440,uni044E,uni0450,uni0451",
    g2: "quotedbl,quotesingle,asterisk,grave,ordfeminine,macron,ordmasculine,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,oe,uni042A,uni042C,uni0435,uni043E,uni0440,uni044E,uni0450,uni0451",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,oe,uni042A,uni042C,uni0435,uni043E,uni0440,uni044E,uni0450,uni0451",
    g2: "x,z,multiply,uni0436,uni0445",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,oe,uni042A,uni042C,uni0435,uni043E,uni0440,uni044E,uni0450,uni0451",
    g2: "V,W,backslash,Wcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,oe,uni042A,uni042C,uni0435,uni043E,uni0440,uni044E,uni0450,uni0451",
    g2: "T,Y,Ydieresis,uni0422",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,u,dotlessi,uni0438,uni043B,uni043D,uni043F,uni0441,uni0447,uni0448,uni044B,uni044F,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    g2: "quotedbl,quotesingle,asterisk,grave,ordfeminine,macron,ordmasculine,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,u,dotlessi,uni0438,uni043B,uni043D,uni043F,uni0441,uni0447,uni0448,uni044B,uni044F,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    g2: "V,W,backslash,Wcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,u,dotlessi,uni0438,uni043B,uni043D,uni043F,uni0441,uni0447,uni0448,uni044B,uni044F,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    g2: "T,Y,Ydieresis,uni0422",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at,D,G,O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,uni041E,uni0424,uni042D,uni042E",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at,D,G,O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,uni041E,uni0424,uni042D,uni042E",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at,D,G,O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,uni041E,uni0424,uni042D,uni042E",
    g2: "seven,X,Z,uni040E,uni0416,uni0423,uni0425",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at,D,G,O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,uni041E,uni0424,uni042D,uni042E",
    g2: "V,W,backslash,Wcircumflex",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at,D,G,O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,uni041E,uni0424,uni042D,uni042E",
    g2: "T,Y,Ydieresis,uni0422",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,asterisk,grave,dieresis,ordfeminine,macron,degree,acute,ordmasculine,circumflex,breve,dotaccent,ring,tilde,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,cacute,ccircumflex,cdotaccent,ccaron,dcaron,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,omacron,obreve,oe,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,asterisk,grave,dieresis,ordfeminine,macron,degree,acute,ordmasculine,circumflex,breve,dotaccent,ring,tilde,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron,uni0432,uni0433,uni0438,uni043A,uni043B,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044D,uni044E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,asterisk,grave,dieresis,ordfeminine,macron,degree,acute,ordmasculine,circumflex,breve,dotaccent,ring,tilde,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "at,C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,OE,uni041E,uni0421,uni0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,asterisk,grave,dieresis,ordfeminine,macron,degree,acute,ordmasculine,circumflex,breve,dotaccent,ring,tilde,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,asterisk,grave,dieresis,ordfeminine,macron,degree,acute,ordmasculine,circumflex,breve,dotaccent,ring,tilde,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,s,uni0430,uni0437,uni044F",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,asterisk,grave,dieresis,ordfeminine,macron,degree,acute,ordmasculine,circumflex,breve,dotaccent,ring,tilde,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "u",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "at,C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,OE,uni041E,uni0421,uni0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "quotedbl,quotesingle,asterisk,grave,ordfeminine,macron,ordmasculine,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "x,z,multiply,uni0436,uni0445",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "V,W,backslash,Wcircumflex",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "T,Y,Ydieresis,uni0422",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,L,backslash,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Lacute,uni013B,Lslash,uni0410,uni0414,uni041C",
    g2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "c,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,cacute,ccircumflex,cdotaccent,ccaron,dcaron,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,omacron,obreve,oe,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "at,C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,OE,uni041E,uni0421,uni0424",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "seven,X,Z,uni040E,uni0416,uni0423,uni0425",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "x,z,multiply,uni0436,uni0445",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "V,W,backslash,Wcircumflex",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,v,w,y,racute,uni0157,rcaron,uni0433,uni0442,uni0443,uni0453",
    g2: "T,Y,Ydieresis,uni0422",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight,B,C,germandbls,uni0411,uni0412,uni0417,uni0421",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight,B,C,germandbls,uni0411,uni0412,uni0417,uni0421",
    g2: "seven,X,Z,uni040E,uni0416,uni0423,uni0425",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight,B,C,germandbls,uni0411,uni0412,uni0417,uni0421",
    g2: "V,W,backslash,Wcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight,B,C,germandbls,uni0411,uni0412,uni0417,uni0421",
    g2: "T,Y,Ydieresis,uni0422",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,z,uni0137,kgreenlandic,zcaron,uni0436,uni043A,uni0445",
    g2: "c,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,cacute,ccircumflex,cdotaccent,ccaron,dcaron,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,omacron,obreve,oe,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,z,uni0137,kgreenlandic,zcaron,uni0436,uni043A,uni0445",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,z,uni0137,kgreenlandic,zcaron,uni0436,uni043A,uni0445",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,z,uni0137,kgreenlandic,zcaron,uni0436,uni043A,uni0445",
    g2: "x,z,multiply,uni0436,uni0445",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,z,uni0137,kgreenlandic,zcaron,uni0436,uni043A,uni0445",
    g2: "V,W,backslash,Wcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,z,uni0137,kgreenlandic,zcaron,uni0436,uni043A,uni0445",
    g2: "T,Y,Ydieresis,uni0422",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,z,uni0137,kgreenlandic,zcaron,uni0436,uni043A,uni0445",
    g2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "c,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,cacute,ccircumflex,cdotaccent,ccaron,dcaron,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,omacron,obreve,oe,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron,uni0432,uni0433,uni0438,uni043A,uni043B,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044D,uni044E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "at,C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,OE,uni041E,uni0421,uni0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "x,z,multiply,uni0436,uni0445",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "a,s,uni0430,uni0437,uni044F",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "V,W,backslash,Wcircumflex",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "T,Y,Ydieresis,uni0422",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash,seven,V,W,Wcircumflex,uni040E,uni0423",
    g2: "u",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "c,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,cacute,ccircumflex,cdotaccent,ccaron,dcaron,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,omacron,obreve,oe,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron,uni0432,uni0433,uni0438,uni043A,uni043B,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044D,uni044E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "at,C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,OE,uni041E,uni0421,uni0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "seven,X,Z,uni040E,uni0416,uni0423,uni0425",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "x,z,multiply,uni0436,uni0445",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "a,s,uni0430,uni0437,uni044F",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "V,W,backslash,Wcircumflex",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "T,Y,Ydieresis,uni0422",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Y,Yacute,Ydieresis,uni0413,uni0422",
    g2: "u",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Z,uni0416,uni041A,uni0425",
    g2: "c,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,cacute,ccircumflex,cdotaccent,ccaron,dcaron,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,omacron,obreve,oe,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Z,uni0416,uni041A,uni0425",
    g2: "at,C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,OE,uni041E,uni0421,uni0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Z,uni0416,uni041A,uni0425",
    g2: "v,w,y,yacute,ydieresis,uni0443,uni045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Z,uni0416,uni041A,uni0425",
    g2: "x,z,multiply,uni0436,uni0445",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Z,uni0416,uni041A,uni0425",
    g2: "V,W,backslash,Wcircumflex",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Z,uni0416,uni041A,uni0425",
    g2: "T,Y,Ydieresis,uni0422",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Z,uni0416,uni041A,uni0425",
    g2: "u",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine,question,F,P,uni0420",
    g2: "c,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,cacute,ccircumflex,cdotaccent,ccaron,dcaron,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,omacron,obreve,oe,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine,question,F,P,uni0420",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron,uni0432,uni0433,uni0438,uni043A,uni043B,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044D,uni044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine,question,F,P,uni0420",
    g2: "comma,period,slash,A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,uni0410,uni0414,uni0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine,question,F,P,uni0420",
    g2: "seven,X,Z,uni040E,uni0416,uni0423,uni0425",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine,question,F,P,uni0420",
    g2: "a,s,uni0430,uni0437,uni044F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine,question,F,P,uni0420",
    g2: "T,Y,Ydieresis,uni0422",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine,question,F,P,uni0420",
    g2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,j,jcircumflex",
    g2: "J,j,jcircumflex",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q",
    g2: "quotedbl,quotesingle,asterisk,grave,ordfeminine,macron,ordmasculine,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q",
    g2: "V,W,backslash,Wcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q",
    g2: "T,Y,Ydieresis,uni0422",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q",
    g2: "J,j,jcircumflex",
    k: -60
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJostRegular);
export default __webpack_public_path__ + "static/media/Jost-Regular.6f818dc1915100f947054743f28e8420.svg";
export { ForwardRef as ReactComponent };